export const wonderousItems = [
    {
        rarity: "common",
        type: ["untyped"],
        name: `Ioun Torch`,
        longDesc: `You increase your vision on dark and lowlight maps by 50%. If the map has fog or smoke, this item does not work.`,
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Lord's Crusading Banner`,
        longDesc: `A lord's banner is a cloth flag or standard, typically at least 2 feet wide and 4 feet long, meant to be carried and displayed on a spear, polearm, or staff (movement action to attach). It has no effect when not mounted properly or when laying on the ground.
        \nA lord's banner may be carried or planted. In the latter case, the banner does not need a bearer, but if it is toppled or touched by an enemy, it loses its effectiveness until reclaimed and replanted by allies of its owner. 
        \nThis banner emits a constant hallow (as the spell, CL10) effect in a 40-foot radius around it.`,
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Lord's Banner of Victory`,
        longDesc: `A lord's banner is a cloth flag or standard, typically at least 2 feet wide and 4 feet long, meant to be carried and displayed on a spear, polearm, or staff (movement action to attach). It has no effect when not mounted properly or when laying on the ground.
        \nA lord's banner may be carried or planted. In the latter case, the banner does not need a bearer, but if it is toppled or touched by an enemy, it loses its effectiveness until reclaimed and replanted by allies of its owner. 
        \nThis banner confers allies of the owner of the banner with a +2 morale bonus on attack rolls, saves, and skill checks for as long as they can see the banner.`,
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Lord's Banner of Terror`,
        longDesc: `A lord's banner is a cloth flag or standard, typically at least 2 feet wide and 4 feet long, meant to be carried and displayed on a spear, polearm, or staff (movement action to attach). It has no effect when not mounted properly or when laying on the ground.
        \nA lord's banner may be carried or planted. In the latter case, the banner does not need a bearer, but if it is toppled or touched by an enemy, it loses its effectiveness until reclaimed and replanted by allies of its owner. 
        \nThis banner emits an aura of fear, while within 30 feet and able to see the banner, enemies must make a Will saving throw (DC 16) or become panicked, fleeing as quickly as possible for as long as they can see the banner. Those that succeed on the save are shaken. A creature that makes its saving throw is immune to the banner's effects for 1 day.`,
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Lord's Banner of Swiftness`,
        longDesc: `A lord's banner is a cloth flag or standard, typically at least 2 feet wide and 4 feet long, meant to be carried and displayed on a spear, polearm, or staff (movement action to attach). It has no effect when not mounted properly or when laying on the ground.
        \nA lord's banner may be carried or planted. In the latter case, the banner does not need a bearer, but if it is toppled or touched by an enemy, it loses its effectiveness until reclaimed and replanted by allies of its owner. 
        \nThis banner emits an aura of swiftness in 30 feet around it, all allies that start their turn within the aura gain a 10-foot enhancement bonus to their movement speed for 1 round.`,
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Banner of the Ancient Kings`,
        longDesc: `When carried into battle, a banner of the ancient kings confers several benefits. First, to use it, you must attach it to a polearm or spear as a movement action, or you can choose to wield it in one hand. Then, as long as you are holding the banner or the weapon, you gain a +4 circumstance bonus on Initiative checks. In addition, when so wielded, it grants you and all allies within 30 feet a +2 resistance bonus on all saving throws against mind-affecting effects. If you fail a saving throw against a mind-affecting effect, you may attempt a new saving throw against that effect every round you continue to wield the banner of the ancient kings—once you release your firm grip on the banner's haft, though, you no longer get this benefit, even if you wield the banner properly at a later point while still under the effects of the mind-affecting effect.
        \nIf the banner's carrier possesses the bardic performance perk, the bonus granted by inspire courage and timed advice increases by +1. Inspire courage has its spell point cost per round increased accordingly. If you have the flagbearer feat, this flag meets the requirement of holding a flag (even if it is attached to a polearm or spear).`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Alluring Golden Apple`,
        longDesc: `When dropped or thrown, it draws the attention of the nearest hostile creature within 20 feet. The creature must make a Will save, its DC being equal to your choice of a diplomacy or bluff check, or be paralyzed as if by hold monster as it focuses its undivided attention on the golden apple. If the creature makes its save on a later round, it realizes it has been affected by magic and the apple is not actually gold. While focusing on the apple, the target takes a —2 penalty on Perception checks. The apple is consumed upon being dropped or thrown.`,
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Luck Stone`,
        longDesc: `This small bit of agate grants its possessor a +1 luck bonus on saving throws, ability checks, and skill checks.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Agile Alpenstock`,
        longDesc: `This gnarled wooden walking stick aids a creature's travel, granting a +5 foot enhancement bonus to speed and a +2 enhancement bonus to CMD against trip attempts and on saving throws to avoid being tripped. These bonuses apply as long as the agile alpenstock is held in hand. It can be wielded in combat as a quarterstaff.`,
    },
    {
        rarity: "common",
        type: ["shoulders"],
        name: `Handyish Haversack`,
        longDesc: `Once per day you can draw an item from your bag as a swift action that does not provoke`,
    },
    {
        rarity: "rare",
        type: ["shoulders"],
        name: `Handy Haversack`,
        longDesc: `Once per combat you can draw an item from your bag as a swift action that does not provoke`,
    },
    {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Handier Haversack`,
        longDesc: `Drawing items from your bag becomes a swift action that does not provoke. You can only do this once per turn.`,
    },
    {
        rarity: "unique",
        type: ["shoulders"],
        name: `Handiest Haversack`,
        longDesc: `Drawing items from your bag becomes a free action that does not provoke. You can only do this once per turn, however you can draw additional items as swift actions.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Potion Bottle`,
        longDesc: `You can swallow this potion bottle as a movement action. Then, the next time you drink a potion, the potion bottle affects you as normal, but also fills the potion bottle. Then, at a later time you can vomit the potion bottle back up, re-adding the potion it contains to your hand or your gear. A potion bottle can only be used once per floor, and must be swallowed again each floor to be used.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Word Bottle`,
        longDesc: `As a part of casting a targeted language-dependant spell, the action becomes at least a standard action, you can cast it into the flask, which charges the flask with power. Any of the spell's variables that are determined by its caster (such as commands given to the spell's target) are decided when the spell is cast into the bottle.
        \nThe charged flask can be thrown as a splash weapon with a range increment of 10 feet. The flask shatters and is destroyed upon impact, releasing the stored spell. A creature struck by the flask is subject to the effects of spell contained within, just as if it had been the target of the spell. Creatures within 5 feet of the flask when it breaks hear whispery echoes of the spell's words and are also subject to its effects, though they receive a +5 bonus on their saves to resist the spell. If the spell does not ordinarily allow a save, creatures caught in the splash radius may still make a Will save to negate it (with the +5 bonus).`,
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Akashic Lockpick`,
        longDesc: `This item can be used to pick open an item chest of any kind, allowing you to obtain it for free. Once you do this, this item crumbles to dust.`,
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Tome of Bodily Power +1`,
        longDesc: `Grants a +1 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["physical"],
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Tome of Mental Power +1`,
        longDesc: `Grants a +1 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["mental"],
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Tome of Bodily Power +2`,
        longDesc: `Grants a +2 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["physical"],
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Tome of Mental Power +2`,
        longDesc: `Grants a +2 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["mental"],
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Tome of Bodily Power +3`,
        longDesc: `Grants a +3 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["physical"],
    },
    
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Tome of Mental Power +3`,
        longDesc: `Grants a +3 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["mental"],
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Tome of Bodily Power +4`,
        longDesc: `Grants a +4 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["physical"],
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Tome of Mental Power +4`,
        longDesc: `Grants a +4 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["mental"],
    },
    {
        rarity: "unique",
        type: ["untyped"],
        name: `Tome of Bodily Power +6`,
        longDesc: `Grants a +6 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["physical"],
    },
    {
        rarity: "unique",
        type: ["untyped"],
        name: `Tome of Mental Power +6`,
        longDesc: `Grants a +6 inherent bonus to the listed ability score as long as you have this book.`,
        rolls: ["mental"],
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Bead of Newt Prevention`,
        longDesc: `This bead is carved with a tiny pictogram representing a small, harmless animal such as a newt, rabbit, or frog. If the bearer fails a saving throw against a hostile polymorph effect such as baleful polymorph, the bead is destroyed and the effect does not affect the bearer. Alternatively, if you encounter a newt, you may throw this a ranged touch attack, if it hits, the newt has a 50% chance of dying instantly. This also destroyes the bead.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Efficient Quiver`,
        longDesc: `You can store 3 extra stacks of ammunition on this, and 3 grenades. Drawing any of these items from the quiver becomes a free action which does not provoke.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Pearl of Power Level 1`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 3. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Pearl of Power Level 2`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 6. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Pearl of Power Level 3`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 9. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "rare",
        type: ["untyped"],
        name: `Pearl of Power Level 4`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 12. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Pearl of Power Level 5`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 15. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Pearl of Power Level 6`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 18. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "epic",
        type: ["untyped"],
        name: `Pearl of Power Level 7`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 21. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Pearl of Power Level 8`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 24. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "legendary",
        type: ["untyped"],
        name: `Pearl of Power Level 9`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 27. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "unique",
        type: ["untyped"],
        name: `Pearl of Power Level 10`,
        longDesc: `When you obtain this item, your current and maximum spell points are increased by 30. If the item is lost for any reason, your current and maximum spell points are reduced back.`,
    },
    {
        rarity: "common",
        type: ["untyped"],
        name: `Steadfast Gut-Stone`,
        longDesc: `This fist sized chunk of off-white stone seems too large to fit inside a human's mouth, but may be swallowed with ease as a movement action. Once ingested, the gut-stone maneuvers itself within the body to protect its bearer's vital organs. Any time an attack would subject the bearer to precision-based damage (such as a critical hit or sneak attack), that damage is instead directed to the gut-stone. All other damage from the triggering attack, as well as damage that surpasses the gut-stone's hit points, is applied to the character normally. A gut-stone has 10 hit points and hardness 8.
        \nWhen a gut-stone is damaged by a melee weapon attack, as a free action its owner may sacrifice the stone to damage the attacker's weapon. Treat this as the bearer making a free sunder combat maneuver against the weapon, except that it does not provoke an attack of opportunity, bypasses the weapon's hardness, and deals 1d4 points of damage.`,
    },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Ammo Fabricator`,
        longDesc: `You count as having quickdraw for throwing ranged weapons, and reduce the reload time for firearms and crossbows by 1 step, but only if you're reloading physically.`,
        },
        {
            rarity: "common",
            type: ["ring"],
            name: `Kyton Ring`,
            longDesc: `Once per day as a standard action the ring can launch a chain as a ranged touch attack with a range of 60 feet, you can use this on a sturdy wall that could support your weight, or on a creature. If you hit, and it is a creature larger than you, or a study wall, you can pull yourself to the creature, this provokes attacks of opportunity as normal. If the creature is your size or smaller you can instead make a CMB check to trip them, or pull them to you, placing them in the closest adjacent square. Their movement does not provoke.`,
        },
        {
            rarity: "common",
            type: ["ring"],
            name: `Deadeye's Spotter Ring`,
            longDesc: `As a free action at the start of your turn you can decalre a single creature and a single ally, that ally does not take penalties to fighting firing ranged weapons into melee against that creature if you're the only creature that threatens that creature. If they already would not take penalties, they gain a +1 bonus to attacks against it.`,
        },
        {
            rarity: "common",
            type: ["ring"],
            name: `Ring of Balanced Grip`,
            longDesc: `Gain a +1 enhancement bonus on non-unarmed weapon attacks.`,
        },
        {
            rarity: "common",
            type: ["ring"],
            name: `Ring of Starlight`,
            longDesc: `You emit 10 ft of low-light.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Ring of Serene Contortions`,
            longDesc: `Once per day as a free action you can cast true strike on yourself.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Ring of Lingering Blood Magic`,
            longDesc: `As a free action you can take once per round, you sacrifice level hit points to make a spell currently effecting you last 1 round longer.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Ring of the Sublime`,
            longDesc: `You gain a +5 bonus on saves against fear effects.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Ring of Emancipation`,
            longDesc: `Gain a +5 bonus on escape artist checks and disable device checks. You can attempt to escape artist to escape a creatures grapple as a move action.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Knight-Inheritor's Ring`,
            longDesc: `Your weapon attacks gain a +1 enhancement bonus when attacking evil creatures, and bypasses DR evil.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Profane Seal Signet`,
            longDesc: `This ring grants a +1 deflection bonus to armor class, and you can use it to cast the spell 'Wrath' once per day.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Ring of Powerful Blood Magic`,
            longDesc: `As a swift action up to three times per day, while casting a spell, you can sacrifice level hit points to increase the spells DC by +1. If you use siphon from hemomancy you deal an extra dice of damage, but it doesn't cost additional spell points.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Ring of Ancestral Blood Magic`,
            longDesc: `Once per day you can sacrifice hit points in place of spell points for a spell. If you use hemomancy reduce the cost of it by 2 spell points.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Ring of Vengeful Blood Magic`,
            longDesc: `Three time per day, when a foe provokes an attack of opportunity from him, the wearer can cast a spell with a casting time of 1 standard action or less as the attack of opportunity. The spell must target the creature that provoked the attack or include it in the spell's area, and must be no higher than 3rd level. This counts as one of the wearer's attacks of opportunity for the round; casting this spell does not itself provoke an attack of opportunity. You can always use hemomancy for this attack of opportunity, and if you do it costs 50% spell points.`,
        },
        {
            rarity: "legendary",
            type: ["ring"],
            name: `Ring of the Potion Glutton`,
            longDesc: `Each floor you must consume potions equal to your level or at the end of the floor you take level constitution damage. Drinking potions is now a swift action, but still provokes.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Ring of Far Strike`,
            longDesc: `This unassuming black ring changes color to a silver pearlescent sheen when held near a fire. Once per day the wearer can make a melee weapon attack or unarmed strike attack against any opponent within 30 feet. The wearer must be otherwise capable of performing the attack to use this ability.`,
        },
        {
            rarity: "common",
            type: ["ring"],
            name: `Ring of Delayed Doom`,
            longDesc: `This band has one garnet embedded along its exterior. Whenever the wearer's mind or body first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 minute, after he fails the saving throw but before its effects occur. This activation causes one of the garnets to turn to powder. When that minute passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another minute. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 minute after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several minutes). Effects that protect against or negate the harmful effect work normally while it is delayed, for example, neutralize poison cast on the wearer while he delays the effect of a poisonous bite removes the poison effect.`,
        },
        {
            rarity: "rare",
            type: ["ring"],
            name: `Ring of Delayed Doom`,
            longDesc: `This band has three garnets embedded along its exterior. Whenever the wearer's mind or body first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 minute, after he fails the saving throw but before its effects occur. This activation causes one of the garnets to turn to powder. When that minute passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another minute. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 minute after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several minutes). Effects that protect against or negate the harmful effect work normally while it is delayed, for example, neutralize poison cast on the wearer while he delays the effect of a poisonous bite removes the poison effect.`,
        },
        {
            rarity: "epic",
            type: ["ring"],
            name: `Ring of Delayed Doom`,
            longDesc: `This band has 5 garnets embedded along its exterior. Whenever the wearer's mind or body first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 minute, after he fails the saving throw but before its effects occur. This activation causes one of the garnets to turn to powder. When that minute passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another minute. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 minute after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several minutes). Effects that protect against or negate the harmful effect work normally while it is delayed, for example, neutralize poison cast on the wearer while he delays the effect of a poisonous bite removes the poison effect.`,
        },
        {
            rarity: "legendary",
            type: ["ring"],
            name: `Ring of Delayed Doom`,
            longDesc: `This band has 7 garnets embedded along its exterior. Whenever the wearer's mind or body first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 minute, after he fails the saving throw but before its effects occur. This activation causes one of the garnets to turn to powder. When that minute passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another minute. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 minute after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several minutes). Effects that protect against or negate the harmful effect work normally while it is delayed, for example, neutralize poison cast on the wearer while he delays the effect of a poisonous bite removes the poison effect.`,
        },
        {
            rarity: "unique",
            type: ["ring"],
            name: `Ring of Delayed Doom`,
            longDesc: `This band has 10 garnets embedded along its exterior. Whenever the wearer's mind or body first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 minute, after he fails the saving throw but before its effects occur. This activation causes one of the garnets to turn to powder. When that minute passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another minute. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 minute after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several minutes). Effects that protect against or negate the harmful effect work normally while it is delayed, for example, neutralize poison cast on the wearer while he delays the effect of a poisonous bite removes the poison effect.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Golden Holy Symbol`,
        longDesc: `You must be good to use this item. Whenever you use a magical perk or cast spell to heal hit points (though it cannot only target/effect you), you heal hit points equal to your level/2 or level of the spell. When casting a spell that heals hit points you can spend an additional level/2 spell points to cause the amulet to glow with a warm light, reduce darkness within 20 feet by one step (CL10), and all allies within 20 feet of you when you end your turn (excluding you) heal 1d6+level/2. This lasts rounds equal to the spells level/2.`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Amulet of Mighty Fists +1`,
            longDesc: `This amulet grants an enhancement bonus of +1 on attack and damage rolls with unarmed attacks and natural weapons. This stacks with any enhancement bonus those attacks may already have.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of Mighty Fists +2`,
            longDesc: `This amulet grants an enhancement bonus of +2 on attack and damage rolls with unarmed attacks and natural weapons. This stacks with any enhancement bonus those attacks may already have. You can instead apply this bonus to melee weapon attacks, but its bonus is only +1, and you cannot apply it to weapons and natural attacks on the same turn.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of Mighty Fists +3`,
            longDesc: `This amulet grants an enhancement bonus of +3 on attack and damage rolls with unarmed attacks and natural weapons. This stacks with any enhancement bonus those attacks may already have. You can instead apply this bonus to melee weapon attacks, but its bonus is only +1 and you cannot apply it to weapons and natural attacks on the same turn.`,
        },
        {
            rarity: "legendary",
            type: ["neck"],
            name: `Amulet of Mighty Fists +4`,
            longDesc: `This amulet grants an enhancement bonus of +4 on attack and damage rolls with unarmed attacks and natural weapons. This stacks with any enhancement bonus those attacks may already have. You can instead apply this bonus to melee weapon attacks, but its bonus is only +2 and you cannot apply it to weapons and natural attacks on the same turn.`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Amulet of Mighty Fists +6`,
            longDesc: `This amulet grants an enhancement bonus of +6 on attack and damage rolls with unarmed attacks and natural weapons. This stacks with any enhancement bonus those attacks may already have. You can instead apply this bonus to melee weapon attacks, but its bonus is only +3 and you cannot apply it to weapons and natural attacks on the same turn.`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Choker of the Beast`,
            longDesc: `This choker can only be worn by evil creatures. The wearer gains a +2 profane bonus on all saving throws. If the wearer is chaotic evil this increases to +3. If you have the touch of corruption perk or the ability to channel negative energy the dice step of the ability increases by 1 step (1d6->1d8). Good aligned creatures within 30 feet of you must make a will save DC 18+charisma mod or be shaken while in range. If the wearer willingly breaks the choker in half as a full-round action, or they are dead for 1d6+1 rounds the ground ruptures open and consumes your body, and 1d4 rounds after a fiendish carnivorous blob spawns from your location and attacks any living creature in sight (closest first).`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Choker of Valor`,
            longDesc: `This choker can only be worn by good creatures. The wearer gains a +2 sacred bonus on all saving throws. If the wearer is lawful good this increases to +3. If you have the lay on hands perk or the ability to channel positive energy the dice step of the ability increases by 1 step (1d6->1d8). Evil aligned creatures within 30 feet of you must make a will save DC 18+charisma mod or be shaken while in range. If the wearer willingly breaks the choker in half as a full-round action, or they are dead for 1d6+1 rounds their body errupts into light, their body consumed in the process, and 1d4 rounds after an astral deva spawns from your location and attacks any evil creature in sight (closest first).`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Obsidian Unholy Symbol`,
        longDesc: `You must be evil to use this item. Whenever you use a spell or perk that deals damage with negative energy you heal level/2 hit points. When casting a spell that deals negative energy you can spend an additional level/2 spell points to cause this amulet to radiate a dark energy, and all living enemies within 20 feet of you (excluding you) when you end your turn take 1d6+level/2 negative energy, you heal hit points equal to half the damage this amulet does. This lasts rounds equal to the spells level/2.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Cloak of Resistance +1`,
        longDesc: `Gain a +1 resistance bonus to all saves`,
        },
        {
            rarity: "rare",
            type: ["shoulders"],
            name: `Bag of Tricks`,
            longDesc: `Once per floor as a standard action you can use the bag to withdraw any gear item as long as it has a stack size larger than 1. This gear item vanishes at the end of the floor if it wasn't used.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Bucket`,
        longDesc: `Gain a +1 armor bonus, which increases to +3 against critical hit confirmations. These bonuses stack with all other armor bonuses.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Stonefist Gloves`,
        longDesc: `These heavy, stone gloves feel surprisingly supple to anyone who puts them on. While a creature wears stonefist gloves, his unarmed strike damage is treated as if he were one size category larger, and bypasses hardness of 8 or lower. When a creature uses these gloves to make a sunder combat maneuver, he gains a +4 bonus.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of Resistance +2`,
        longDesc: `Gain a +2 resistance bonus to all saves`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cloak of Resistance +3`,
        longDesc: `Gain a +3 resistance bonus to all saves`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Cloak of Resistance +5`,
        longDesc: `Gain a +5 resistance bonus to all saves`,
        },
        {
        rarity: "unique",
        type: ["shoulders"],
        name: `Cloak of Resistance +7`,
        longDesc: `Gain a +7 resistance bonus to all saves`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Protection +1`,
        longDesc: `Gain a +1 deflection bonus to armor class`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Protection +2`,
        longDesc: `Gain a +2 deflection bonus to armor class`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Protection +3`,
        longDesc: `Gain a +3 deflection bonus to armor class`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Protection +5`,
        longDesc: `Gain a +5 deflection bonus to armor class`,
        },
        {
        rarity: "unique",
        type: ["ring"],
        name: `Ring of Protection +7`,
        longDesc: `Gain a +7 deflection bonus to armor class`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Amulet of natural Armor +1`,
        longDesc: `Gain a +1 enhancement bonus to your natural armor`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Amulet of Natural Armor +2`,
        longDesc: `Gain a +2 enhancement bonus to your natural armor`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Amulet of Natural Armor +3`,
        longDesc: `Gain a +3 enhancement bonus to your natural armor`,
        },
        {
        rarity: "legendary",
        type: ["neck"],
        name: `Amulet of Natural Armor +5`,
        longDesc: `Gain a +5 enhancement bonus to your natural armor`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Amulet of Special Protection +1`,
            longDesc: `You gain a +1 luck bonus to your armor class against attacks that target your touch armor class`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of Special Protection +2`,
            longDesc: `You gain a +2 luck bonus to your armor class against attacks that target your touch armor class`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of Special Protection +3`,
            longDesc: `You gain a +3 luck bonus to your armor class against attacks that target your touch armor class`,
        },
        {
            rarity: "legendary",
            type: ["neck"],
            name: `Star Cinder`,
            longDesc: `Once per day, the wearer of a star cinder can choose one energy type (acid, cold, electricity, fire, or sonic). Creatures within 60 feet of the wearer with resistance or immunity to the selected energy type have that resistance or immunity suppressed for 12 rounds. Creatures with the elemental subtype are unaffected.`,
        },
        {
            rarity: "legendary",
            type: ["neck"],
            name: `Amulet of Special Protection +5`,
            longDesc: `You gain a +5 luck bonus to your armor class against attacks that target your touch armor class`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Amulet of Special Protection +7`,
            longDesc: `You gain a +7 luck bonus to your armor class against attacks that target your touch armor class`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Rimeheart Amulet`,
            longDesc: `When worn, it freezes the wearer's heart solid, chilling body and soul. The wearer immediately develops hypothermia, becoming permanently fatigued for as long as he wears the amulet, but is otherwise protected against cold weather by a constant endure elements effect. The amulet also grants 10 points of cold resistance, immunity to bleed effects, and a +4 resistance bonus on saving throws against spells with the emotion descriptor. Removing the amulet thaws the wearer's heart but leaves him fatigued until he spends 8 hours warming up.`,
        },
        {
        rarity: "unique",
        type: ["neck"],
        name: `Amulet of Natural Armor +7`,
        longDesc: `Gain a +7 enhancement bonus to your natural armor`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Shrunken Head`,
            longDesc: `While wearing a shrunked head, whenever the wearer use a spell of the fear subtype the DC is increased by +1. Additionally, once per day as an immediate action, the owner can make the head absorb a mind-affecting spell of up to 5th level that was targeting the owner. Absorbing such a spell protects only the wielder, not any other targets. After absorbing the spell, the head's eyes open and burn with pale green fire for 1 round per level of the spell absorbed. While the eyes are burning, as a standard action, the wielder can unleash this energy as enervation, with the ray imposing 1 negative level per level of spell absorbed.`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Amulet of Absolute Magic`,
            longDesc: `As a standard action you can grasp this amulet and cause it to cast any spell level 8 or below, your caster level is treated as 14 for this spell and the spell is treated as a 9th level spell for any save DC's or interaction with other effects or abilities. Regardless of the casting time of the desired spell, it is still cast as a standard action. Once you do this 3 times the amulet crumbles to dust.`,
        },
        {
            rarity: "unique",
            type: ["neck"],
            name: `Talisman of Diabolic Shield`,
            longDesc: `The wearer of this amulet gains the protection of a barbazu. As an immediate action the wearer can attempt to force the barbazu to accept an afflictions about something about to affect them, including damage. You must declare use of this before any roll is made such as your save or the attack roll. Doing so requires a d100 check, on a roll of 51 or above the barbazu accepts the effect for the wearer and the effect is triggered as if it has targeted a barbazu, using its saves, armor class, and resistances. This barbazu is on a totally different plane and provides no help other than being able to accept afflictions for the wearer. This ability cannot be used if the barbazu is unable to take the actions required to cast a spell (such as if it is currently dominated or held because of an affliction you passed to it). The caster of the spell or the ability is aware the barbazu has accepted the affliction for the wearer and any commands given to the wearer are transfered to the barbazu. Once the barbazu has died, the amulet turns to dust.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Sharpening Sheathe`,
        longDesc: `When you draw a slashing or piercing weapon from this sheathe it gains a +3 bonus to its damage until the end of your next turn`,
        },
        {
            rarity: "rare",
            type: ["belt"],
            name: `Quickdraw Belt`,
            longDesc: `You can sheathe one weapon or a set of throwing weapons on this belt, you can draw them as a free action.`,
        },
        {
        rarity: "rare",
        type: ["eyes"],
        name: `Seeing Monacle`,
        longDesc: `once per day you can cast true seeing on yourself (standard) that lasts 3 rounds.`,
        },
        {
        rarity: "common",
        type: ["hands"],
        name: `Skill Item`,
        longDesc: `Gain a +3 competence bonus to the listed Skill`,
        rolls: ["skill"],
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Skill Item`,
        longDesc: `Gain a +6 competence bonus to the listed Skill`,
        rolls: ["skill"],
        },
        {
        rarity: "epic",
        type: ["hands"],
        name: `Skill Item`,
        longDesc: `Gain a +9 competence bonus to the listed Skill`,
        rolls: ["skill"],
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Skill Item`,
        longDesc: `Gain a +15 competence bonus to the listed Skill`,
        rolls: ["skill"],
        },
        {
        rarity: "unique",
        type: ["hands"],
        name: `Skill Item`,
        longDesc: `Gain a +20 competence bonus to the listed Skill`,
        rolls: ["skill"],
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Handy Haversack`,
        longDesc: `Once per day you can retrieve an item from your inventory as a free action that does not provoke an attack of opportunity. This includes potions, gems, and gear items (not weapons).`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Bandolier`,
        longDesc: `You can store 2 items on your Bandolier (after drawing them normally). Retrieving an item stored on your bandolier is a swift action that does not provoke attacks of opportunity. At the end of a floor you can also add a single item from your gear to your bandolier.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Belt of Physical Power +2`,
        longDesc: `Gain a +2 enhancement bonus to a physical score`,
        rolls: ["physical"],
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Belt of Mental Power +2`,
        longDesc: `Gain a +2 enhancement bonus to a mental score`,
        rolls: ["mental"],
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Physical Might +2`,
        longDesc: `Gain a +2 enhancement bonus to 2 physical ability scores`,
        rolls: ["physical","physical",],
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Mental Prowess +2`,
        longDesc: `Gain a +2 enhancement bonus to 2 mental ability scores`,
        rolls: ["mental","mental",],
        },
        {
        rarity: "rare",
        type: ["belt","headband"],
        name: `Headbelt of Physical Intelligence +2`,
        longDesc: `Gain a +2 enhancement bonus to a physical ability score and a mental ability score`,
        rolls: ["physical","mental",],
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Physical Power +4`,
        longDesc: `Gain a +4 enhancement bonus to a physical score`,
        rolls: ["physical"],
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Mental Power +4`,
        longDesc: `Gain a +4 enhancement bonus to a mental score`,
        rolls: ["mental"],
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Physical Power +6`,
        longDesc: `Gain a +6 enhancement bonus to a physical score`,
        rolls: ["physical"],
        },
        {
        rarity: "epic",
        type: ["headband"],
        name: `Headband of Mental Power +6`,
        longDesc: `Gain a +6 enhancement bonus to a mental score`,
        rolls: ["mental"],
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Physical Might +4`,
        longDesc: `Gain a +4 enhancement bonus to 2 physical ability scores`,
        rolls: ["physical","physical",],
        },
        {
        rarity: "epic",
        type: ["headband"],
        name: `Headband of Mental Prowess +4`,
        longDesc: `Gain a +4 enhancement bonus to 2 mental ability scores`,
        rolls: ["mental","mental",],
        },
        {
        rarity: "epic",
        type: ["belt","headband"],
        name: `Headbelt of Prowess +4`,
        longDesc: `Gain a +4 enhancement bonus to a physical ability score and a mental ability score`,
        rolls: ["physical","mental",],
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Physical Perfection +2`,
        longDesc: `Gain a +2 enhancement bonus to strength, dexterity, and constitution`,
        },
        {
        rarity: "epic",
        type: ["headband"],
        name: `Headband of Mental Perfection +2`,
        longDesc: `Gain a +2 enhancement bonus  to wisdom, intelligence, and charisma`,
        },
        {
        rarity: "epic",
        type: ["belt","headband"],
        name: `Headbelt of Perfection +2`,
        longDesc: `Gain a +2 enhancement bonus to 3 random ability scores`,
        rolls: ["random","random","random",],
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Belt of Physical Power +8`,
        longDesc: `Gain a +8 enhancement bonus to a physical score`,
        rolls: ["physical"],
        },
        {
        rarity: "legendary",
        type: ["headband"],
        name: `Headband of Mental Power +8`,
        longDesc: `Gain a +8 enhancement bonus to a mental score`,
        rolls: ["mental"],
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Belt of Physical Might +6`,
        longDesc: `Gain a +6 enhancement bonus to 2 physical ability scores`,
        rolls: ["physical","physical"],
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Belt of Physical Perfection +4`,
        longDesc: `Gain a +4 enhancement bonus to strength, dexterity, and constitution`,
        },
        {
        rarity: "legendary",
        type: ["headband"],
        name: `Headband of Mental Perfection +4`,
        longDesc: `Gain a +4 enhancement bonus  to wisdom, intelligence, and charisma`,
        },
        {
        rarity: "legendary",
        type: ["belt","headband"],
        name: `Headbelt of Vast Prowess +2`,
        longDesc: `Gain a +2 enhancement bonus to 2 physical ability scores and 2 mental ability scores`,
        rolls: ["physical","physical","mental","mental",],
        },
        {
        rarity: "legendary",
        type: ["belt","headband"],
        name: `Headbelt of Prowess +6`,
        longDesc: `Gain a +6 enhancement bonus to a physical ability score and a mental ability score`,
        rolls: ["physical","mental",],
        },
        {
        rarity: "unique",
        type: ["belt"],
        name: `Belt of Physical Power +10`,
        longDesc: `Gain a +10 enhancement bonus to a physical score`,
        rolls: ["physical"],
        },
        {
        rarity: "unique",
        type: ["headband"],
        name: `Headband of Mental Power +10`,
        longDesc: `Gain a +10 enhancement bonus to a mental score`,
        rolls: ["mental"],
        },
        {
        rarity: "unique",
        type: ["belt"],
        name: `Belt of Physical Might +8`,
        longDesc: `Gain a +8 enhancement bonus to 2 physical ability scores`,
        rolls: ["physical","physical",],
        },
        {
        rarity: "unique",
        type: ["belt"],
        name: `Belt of Physical Perfection +6`,
        longDesc: `Gain a +6 enhancement bonus to strength, dexterity, and constitution`,
        },
        {
        rarity: "unique",
        type: ["headband"],
        name: `Headband of Mental Perfection +6`,
        longDesc: `Gain a +6 enhancement bonus  to wisdom, intelligence, and charisma`,
        },
        {
        rarity: "legendary",
        type: ["belt","headband"],
        name: `Headbelt of Vast Prowess +4`,
        longDesc: `Gain a +4 enhancement bonus to 2 physical ability scores and 2 mental ability scores`,
        rolls: ["physical","physical","mental","mental",],
        },
        {
        rarity: "unique",
        type: ["belt","headband"],
        name: `Headbelt of Prowess +8`,
        longDesc: `Gain a +8 enhancement bonus to a physical ability score and a mental ability score`,
        rolls: ["physical","mental",],
        },
        {
        rarity: "legendary",
        type: ["belt","headband"],
        name: `Headbelt of Complete Perfection +2`,
        longDesc: `Gain a +2 enhancement bonus to all ability scores.`,
        },
        {
        rarity: "unique",
        type: ["belt","headband"],
        name: `Headbelt of Complete Perfection +4`,
        longDesc: `Gain a +4 enhancement bonus to all ability scores.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Plague Rat Belt `,
        longDesc: `This belt grants its wearer a +2 enhancement bonus to Constitution. Also, as an immediate action three times per day, the wearer can call upon the belt to reroll a saving throw made to resist a disease or poison. The wearer must use the second roll, even if it is worse.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Greater Plague Rat Belt`,
        longDesc: `This belt grants its wearer a +2 enhancement bonus to Constitution and dexterity. Gain a +4 bonus to saves against poison and disease. Also, as an immediate action three times per day, the wearer can call upon the belt to reroll a saving throw made to resist a disease or poison. The wearer must use the second roll, even if it is worse.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Climber's Vest`,
        longDesc: `Gain a climb speed of 20 feet and a +8 racial bonus to climb checks.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Flippers`,
        longDesc: `Gain a swim speed of 20 feet and a +8 racial bonus to swim checks.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of the Weasel`,
        longDesc: `Gain a +2 enhancement bonus to dexterity, you can move while prone at no penalty, and you gain no armor class penalty from being prone. Lastly you get the compression ability which allows you to move through an area as small as one-quarter your space without squeezing or one-eighth your space when squeezing.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Thunderous Charging`,
        longDesc: `Gain a +2 enhancement bonus to strength, and a +2 bonus to your CMB when making a bullrush and overrun maneuvers, and when making a charge attack your weapons and natural weapons deal damage as if you were one size larger.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Minotaur Belt`,
        longDesc: `Gain a +2 enhancement bonus to strength, and while charging you can ignore difficult terrain.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Equilibrium`,
        longDesc: `As long as this belt's wearer doesn't move more than 5 feet during her turn, they ignore the penalties for being fatigued, shaken, or sickened until the end of their next turn or until they moves more than 5 feet, whichever occurs first. While they does not take any of the penalties of those conditions, they are considered to be under the effect of those conditions until they end or are removed.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Belt of Hurling`,
        longDesc: `Gain a +2 enhancement bonus to strength, and you can use your strength modifier in place of your dexterity modifier for attacks rolls with throwing weapons.`,
        },
        {
            rarity: "common",
            type: ["belt"],
            name: `Belt of Tumbling`,
            longDesc: `The belt's wearer gains a +5 competence bonus on Acrobatics checks made to move through a threatened square or through an enemy's space.`,
        },
        {
            rarity: "rare",
            type: ["belt"],
            name: `Meridian Belt`,
            longDesc: `This can be slotted with an amulet, ring, or headband, allowing the wearer to gain the benefits of the additional wonderous item.`,
        },
        {
            rarity: "rare",
            type: ["belt"],
            name: `Beneficial Bandolier`,
            longDesc: `This bandolier has slots for 3 additional stacks of ammunition. As a swift action the wearer can command a single round of ammunition from the beneficial bandolier to teleport into the firearm or crossbow of choice that they are wielding. You can store normal non-gear ammunition in the bandolier as well.`,
        },
        {
            rarity: "common",
            type: ["belt"],
            name: `Belt of Teeth`,
            longDesc: `Once each round, this belt's buckle can animate, lashing out at a creature that provokes an attack of opportunity within 5 feet. This attack uses its wearer's base attack bonus and Strength modifier, with a +4 competence bonus. It deals damage as a bite attack made by a creature of its wearer's size (1d6 for a Medium wearer; see Table: Natural Attacks by Size) plus the wearer's Strength modifier. This belt does not add to the normal number of attacks the wearer can make in a round; it offers another way in which to make attacks of opportunity.`,
        },
        {
            rarity: "epic",
            type: ["belt"],
            name: `Belt of Teeth Greater`,
            longDesc: `Once each round, this belt's buckle can animate, lashing out at a creature that provokes an attack of opportunity within 5 feet. This attack uses its wearer's base attack bonus and Strength modifier, with a +4 competence bonus. It deals damage as a bite attack made by a creature of its wearer's size (1d6 for a Medium wearer; see Table: Natural Attacks by Size) plus the wearer's Strength modifier. This belt does not add to the normal number of attacks the wearer can make in a round; instead it can be made in additional to normal attacks of opportunity, even potentially at the same time.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Greater Hurling`,
        longDesc: `Gain a +4 enhancement bonus to strength, and you can use your strength modifier in place of your dexterity modifier for attacks with throwing weapons, and your throwing weapons using strength to determine their damage deal an additional 0.5x of your strength modifier.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Dwarven Kind`,
        longDesc: `Gain a +2 enhancement bonus to constitution and wisdom, and a +2 racial bonus on saves against poison, spells, and spell-like abilities.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Cord of Stubborn Resolve`,
        longDesc: `Gain a +2 enhancement bonus to constitution, and any effect which would cause the wearer to become fatigued deals an additional 1d6 points of damage instead of fatiguing the wearer. Any effect that would cause exhaustion likewise causes 1d6 points of damage and leaves the wearer fatigued instead of exhausted.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Monkey Belt`,
        longDesc: `Gain a +2 enhancement bonus to dexterity, The wearer does not lose his Dexterity bonus to AC while climbing, and does not take a —5 penalty on Climb checks when climbing at half his speed. As a swift action the wearer can command the belt to animate, transforming it into a prehensile tail under the wearer's control. The tail does not grant the wearer any additional attacks or actions per round, nor can it wield weapons, but it can make unarmed attacks and hold or manipulate objects about as well as the wearer's normal limbs (though any activity requiring fingers is beyond the tail's capabilities). The belt can function as a tail for 5 round per day.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Monkey Belt Greater`,
        longDesc: `Gain a +2 enhancement bonus to dexterity and strength, The wearer does not lose his Dexterity bonus to AC while climbing, and does not take a —5 penalty on Climb checks when climbing at half his speed, as well as getting a +5 circumstance bonus to climb checks. As a swift action the wearer can command the belt to animate, transforming it into a prehensile tail under the wearer's control. The tail does not grant the wearer any additional attacks or actions per round, nor can it wield weapons, but it can make unarmed attacks and hold or manipulate objects about as well as the wearer's normal limbs (though any activity requiring fingers is beyond the tail's capabilities). The belt can function as a tail for 10 round per day.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Anaconda's Coil's`,
        longDesc: `Gain a +2 enhancement bonus to strength, a +2 bonus to grapple checks, and In addition, the belt grants the wearer the constrict ability for 1d6 points of damage plus the wearer's Strength modifier.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Serpent Belt`,
        longDesc: `Gain a +4 bonus on saves against poison, and a +8 circumstance bonus to escape artist checks`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Gorgon Belt`,
        longDesc: `Gain a +4 enhancement bonus to Strength, and the ability to ignore difficult terrain while charging or making an overrun, bull rush, or trample attempt. Furthermore, once per day on command, its wearer can spew a 60-foot cone of poisonous green gas as a breath weapon. Any creature caught in the area of the gas can attempt a DC 18 saving throw to resist its effect, but if the creature fails the saving throw, it is paralyzed for 1d4 rounds. At the end of its turn, a creature petrified by this breath weapon can attempt a new save to end the paralysis effect.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Earth Elemental Belt`,
        longDesc: `Gain a +4 enhancement bonus to constitution and the wearer is immune to effects that would push, pull, or forcefully move the wearer. This offers no protection from teleportation effects.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Sash of Flowing Water`,
        longDesc: `If this belt's wearer has at least one hand free (holding nothing), he can attempt to deflect a successful melee attack with an immediate action. To do so, he rolls an unarmed strike against the opponent, including any applicable modifiers such as a favored enemy bonus or the penalty for Power Attack. If his attack roll is greater than the opponent's attack roll, the attack is negated without effect. The unarmed strike itself causes no damage and does not count as a successful attack against the opponent. The opponent does not need to be within the wearer's reach to use this ability. Whether the attack succeeds or not, the wearer takes a —4 penalty on attack rolls until the end of his next turn.`,
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Belt of Stoneskin`,
        longDesc: `This belt's wearer gains DR 10/adamantine until the belt absorbs 100 points of damage, after that the belt becomes useless until the next day.`,
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Shadowform Belt`,
        longDesc: `this belt grants a +6 enhancement bonus to Dexterity. Furthermore, as a swift action, its wearer can become incorporeal until the start of their next turn. While incorporeal, they do not gain a deflection bonus to AC based on their Charisma, but his natural armor bonus is converted to deflection bonus. The wearer can remain incorporeal for up to 5 rounds per day.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Body Wraps of Mighty Strikes +1`,
        longDesc: `Once per round the wearer may add a +1 enhancement bonus to attack and damage to one melee attack, activating this ability must be done before the attack is rolled, but it is not an action so it can be done even when not its turn. For each 10 of your bab you may activate this ability an additional time that round.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Body Wraps of Mighty Strikes +2`,
        longDesc: `Once per round the wearer may add a +2 enhancement bonus to attack and damage to one melee attack, activating this ability must be done before the attack is rolled, but it is not an action so it can be done even when not its turn. For each 10 of your bab you may activate this ability an additional time that round.`,
        },
        {
        rarity: "epic",
        type: ["body"],
        name: `Body Wraps of Mighty Strikes +3`,
        longDesc: `Once per round the wearer may add a +3 enhancement bonus to attack and damage to one melee attack, activating this ability must be done before the attack is rolled, but it is not an action so it can be done even when not its turn. For each 8 of your bab you may activate this ability an additional time that round.`,
        },
        {
        rarity: "legendary",
        type: ["body"],
        name: `Body Wraps of Mighty Strikes +4`,
        longDesc: `Once per round the wearer may add a +4 enhancement bonus to attack and damage to one melee attack, activating this ability must be done before the attack is rolled, but it is not an action so it can be done even when not its turn. For each 8 of your bab you may activate this ability an additional time that round.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Body Wraps of Mighty Strikes +5`,
        longDesc: `Once per round the wearer may add a +5 enhancement bonus to attack and damage to one melee attack, activating this ability must be done before the attack is rolled, but it is not an action so it can be done even when not its turn. For each 6 of your bab you may activate this ability an additional time that round.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Cassock of the Clergy`,
        longDesc: `If wisdom is your highest mental score, reduce the cost of all spells by 1 spell point, they still cost a minimum of 1 spell point, and add +1 to the healing of all healing spells and magic perks that heal per dice rolled. If no dice are rolled this does not affect it.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Robe of Useful Items`,
        longDesc: `Once per day as a movement action you can draw a specific utility gear item. The item created only lasts until the end of the floor.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Blazing Robe`,
        longDesc: `Gain 5 fire resistance, and while casting a spell that deals fire damage increase your caster level for it by 1. Once per day as a movement action you can deal 1d6 per 2 levels (minimum 1d6) of fire damage to all creatures within a 20 foot radius.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Shocking Robe`,
        longDesc: `Gain 5 electricity resistance, and while casting a spell that deals electricity damage increase your caster level for it by 1. Once per day as a movement action you can deal 1d6 per 2 levels (minimum 1d6) of electricity damage to all creatures within a 20 foot radius.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Voidfrost Robe`,
        longDesc: `Gain 5 cold resistance, and while casting a spell that deals cold damage increase your caster level for it by 1. Once per day as a movement action you can deal 1d6 per 2 levels (minimum 1d6) of cold damage to all creatures within a 20 foot radius.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Caustic Robe`,
        longDesc: `Gain 5 acid resistance, and while casting a spell that deals acid damage increase your caster level for it by 1. Once per day as a movement action you can deal 1d6 per 2 levels (minimum 1d6) of acid damage to all creatures within a 20 foot radius.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Mnemonic Vestment`,
        longDesc: `Once per day while casting a spell you can choose that spell to cost 0 spell points. Any spell point modifiers that would increase the spell point cost still cost their usual amount as if this item had not reduced its spell point cost. Spells cast this way have their DC increased by 1`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Monk's Robes`,
        longDesc: `Gain a +3 dodge bonus to your armor class while unarmored, and increase the damage of your unarmed attacks by 1 step.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Xorn Robes`,
        longDesc: `Gain a +5 bonus to perception checks, 10 acid resistance, and every day you can move through natural or worked stone as if using the earth glide spell for a total of 20 feet. This must be used in at least 5-foot increments.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Corset of Dire Witchcraft`,
        longDesc: `Gain a +2 deflection bonus to armor class, and the DC of all of your hexes is increased by +2.`,
        },
        {
        rarity: "legendary",
        type: ["body"],
        name: `Robe of Scintillating Colors`,
        longDesc: `The wearer of this robe can cause the garment to display a shifting pattern of incredible hues, color after color cascading from the upper part of the robe to the hem in sparkling rainbows of dazzling light. The colors daze those near the wearer, conceal the wearer, and illuminate the surroundings. It takes 1 full round after the wearer speaks the command word for the colors to start flowing on the robe. The colors create the equivalent of a gaze attack with a 30-foot range. Those who look at the wearer are dazed for 1d4+1 rounds (Will DC 16 negates). This is a mind-affecting pattern effect.
        
        Every round of continuous scintillation of the robe gives the wearer better concealment. The miss chance on attacks against the wearer starts at 10% and increases by 10% each round until it reaches 50% (total concealment). Additionally, the robe illuminates a 30-foot radius continuously. The effect can be used no more than a total of 10 rounds per day.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Robe of Gates`,
        longDesc: `Three times per day when the wearer uses a summoning spell or spell-like ability to summon a variable number of creatures, he can choose to summon the maximum number of creatures possible. Creatures summoned in this way step from the shadowy folds of the robe, and appear adjacent to the wearer. If there isn't sufficient room for all the creatures to appear, the extra creatures are wasted and do not appear.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Resplendent Thespian`,
        longDesc: `Gain a +4 resistance bonus to all saves, a +3 bonus to overcome creatures spell resistance, and if you have bardic performance increase the bonus granted by inspire courage by +1, (you must spend the extra spell points per round to keep this active), and when using Timed Advice bardic performance ability you roll a d8 instead of a d6.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Archmagi`,
        longDesc: `Gain spell resistance 18, +4 resistance bonus to all saves, a +3 bonus to overcome spell resistance, and reduce the spell point cost of all spells by 1, spells still have a minimum cost of 1. If your highest mental stat is charisma or intelligence you can spend spell points equal to your level as an immediate action to increase your spell resistance by your highest mental modifier for the rest of the round. Additionally when you successfully reduce the effects of a spell on you due to spell resistance or because of a successful save you gain spell points equal to the spells level.`,
        },
        {
        rarity: "legendary",
        type: ["body"],
        name: `Robe of Eyes`,
        longDesc: `This valuable garment appears to be a normal robe until it is put on. Its wearer is able to see in all directions at the same moment due to scores of visible, magical eye-like patterns that adorn the robe. She also gains 120-foot darkvision.
        
        The robe of eyes sees all forms of invisible or ethereal creatures or objects within 120 feet. The wearer of a robe of eyes gains a +10 competence bonus on Perception checks. She retains her Dexterity bonus to AC even when flat-footed, and can't be flanked. She is not able to avert or close her eyes when confronted by a creature with a gaze attack.
        
        A light or continual flame spell cast directly on a robe of eyes causes the wearer to be blinded for 1d3 minutes. A daylight spell blinds the wearer for 2d4 minutes.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Bandages of Recovery`,
        longDesc: `Whenever you are healed by fast healing you heal 1 additional hit point. At the end of each floor you heal hit points equal to your 2x your level.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Bandages of Greater Recovery`,
        longDesc: `Whenever you are healed by fast healing you heal 3 additional hitpoints. At the end of each floor you heal hit points equal to your 3x your level, and restore spell points equal to your level.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Quick Runner's Shirt`,
        longDesc: `Once per day as a swift action, the wearer can take an additional move action to move and then immediately end his turn, losing any unspent actions.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Vest of Surgery`,
        longDesc: `Gain a +5 competence bonus to heal checks to bandage up and emergency aid, once per day when using either action, as long as you heal at least 1 hit point you can also heal 1d4 of ability damage`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Sash of the War Champion`,
        longDesc: `Gain a +1 bonus to attack and damage with all weapon attacks.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Sipping Jacket`,
        longDesc: `As a movement action you can take even while taking a move action to move, you can empty a potion you're holding into this jacket, then later as a swift action cause the potion to affect you. You can activate this ability even if you can only take purely mental actions.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Tunic of Careful Casting`,
        longDesc: `Gain a +2 bonus to concentration checks. Once per day you can increase this bonus to +5.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Vest of Escape`,
        longDesc: `Gain a +4 competence to disable device checks, and a +8 competence bonus to escape artist checks. Once per day as a swift action you can increase the bonus to escape artist checks to +12 for the rest of the round.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Cackling Hag's Blouse`,
        longDesc: `Gain a +2 competence bonus to intimidate, and the ability to cackle 3 times per day. This is a movement action that costs 1 spell point and extends the duration of all hexe's within 30 feet by 1 round. If you already have the ability to cackle you can instead cackle two times per day as a swift action for 1 extra spell point.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Tunic of Deadly Might`,
        longDesc: `Gain a +2 bonus to your CMD vs disarm and sunder attempts, and 3 times per day as a swift action you can cause a successful critical hit with a melee weapon to deal additional damage equal to 1d8 x critical multiplier.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Vest of the Tracker`,
        longDesc: `Gain a +3 competence bonus on skill checks to identify creatures. You also gain a +1 insight bonus to attack and damage against creatures your party has successfully identified the weakness of (dc=20+hd), if you personally identified the creature gain a +2  insight bonus to attack and damage instead. If you personally identified the creature and beat the DC by 8 you instead gain a +3 insight bonus to attack and damage.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Shirt of Immolation`,
        longDesc: `Whenever the wearer is grappling (whether on the offense or defense), this shirt automatically bursts into flame, dealing 1d6+10 points of fire damage every round to anyone grappling the wearer. The flames do not harm the wearer and last one round (though it continues to burn if the wearer is still grappling after one round). The shirt burns for a maximum of 10 rounds per day. These rounds do not need to be consecutive.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Snakeskin Tunic`,
        longDesc: `Gain a +2 enhancement bonus to dexterity, a +2 bonus to saves against poison.`,
        },
        {
        rarity: "epic",
        type: ["chest"],
        name: `Bladric Bane's Sash`,
        longDesc: `Once per day as a standard action you can imbue a single weapon with the bane special quality which it lasts 5 rounds. It must be a weapon you are wielding and it loses the property if you are no longer wielding it. You can swap the bane type as a swift action.`,
        },
        {
        rarity: "epic",
        type: ["chest"],
        name: `Unfettered Shirt`,
        longDesc: `Once per day as a standard action you can gain the effect of freedom of movement for 7 rounds. (CL7)`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Vest of the Cockroach`,
        longDesc: `Once per day when something would cause you to be reduced below 0 hit points you can gain temporary hit points equal to twice your level. These temporary hit points last 1 minute and stack with any other.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Spectral Shroud`,
        longDesc: `The wearer can discern invisible or ethereal creatures as though using see invisibility. Once per day, the wearer can become incorporeal for 5 rounds and gain a fly speed equal to half his base speed with perfect maneuverability. The wearer can't attack or cast spells that affect anything except yourself while incorporeal, but can dismiss the effect as a move action.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Mantle of Spell Resistance`,
        longDesc: `This light mantle bears a variety of mysterious symbols. When worn over normal clothing or armor, this magical garment grants the wearer spell resistance 21.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Mantle of Faith`,
        longDesc: `This cloak provides DR 5/evil to any neutral or good character wearing it.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Mantle of Blasphemy`,
        longDesc: `This cloak provides DR 5/good to any neutral or evil character wearing it.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Merciful Baldric`,
        longDesc: `Once per day when the wearer heals hit points to a creature other than themselves, they can additionally cause the healing effect to remove a single negative condition currently affecting them. If the healing affect targets multiple creatures it can remove the condition from multiple creatures, but it can only remove a single type of condition.`,
        },
        {
        rarity: "common",
        type: ["eyes"],
        name: `Deathwatch Eyes`,
        longDesc: `While wearing deathwatch eyes you gain the effects of deathwatch permanently which allows you to determine the condition of creatures near death within the spell's range. You instantly know whether each creature within the area is dead, fragile (alive and wounded, with 3 or fewer hit points left), fighting off death (alive with 4 or more hit points), healthy, undead, or neither alive nor dead (such as a construct). Deathwatch sees through any spell or ability that allows creatures to feign death. This doesn't work on creatures you cannot see, and this does not allow you to detect creatures you normally cant.`,
        },
        {
        rarity: "common",
        type: ["eyes"],
        name: `Pirate's Eye Patch`,
        longDesc: `The wearer of this patch gains a +2 competence bonus on Swim and Climb checks. In addition, once per day, the wearer of this eye patch can gain the effects of either touch of the sea or expeditious retreat on command (wearer's choice).`,
        },
        {
        rarity: "common",
        type: ["eyes"],
        name: `Treasure Hunter's Goggles`,
        longDesc: `While wearing these goggles, the wearer can use detect secret doors at will. The goggles do not aid in determining how secret doors are opened. Once per day as a standard action, the wearer can locate the location of the nearest pile of gold, and gains a +4 to any check required to obtain it.`,
        },
        {
        rarity: "common",
        type: ["eyes"],
        name: `Goggles of Elvenkind`,
        longDesc: `Increase or gain low-light vision of 60 feet`,
        },
        {
        rarity: "rare",
        type: ["eyes"],
        name: `Goggles of Brilliant Light`,
        longDesc: `Twice per day, the goggles' wearer can emit bright light on command to a range of 30 feet. Any creature within that area must succeed at a DC 13 Fortitude saving throw or be blinded for 1 hour. In addition, the wearer also gains a +2 resistance bonus on saving throws against visual effects.`,
        },
        {
        rarity: "rare",
        type: ["eyes"],
        name: `Blind Man's Folds`,
        longDesc: `A blind man's fold fully obscures normal vision while worn, but grants the effects of the Improved Blind-Fight feat. Creatures which are unable to see normally gain no benefit from wearing a blind man's fold.`,
        },
        {
        rarity: "common",
        type: ["eyes"],
        name: `Goggles of Night`,
        longDesc: `Even though the lenses are opaque, when placed over the eyes of the wearer, they enable him to see normally and also grant him 60-foot darkvision.`,
        },
        {
        rarity: "rare",
        type: ["eyes"],
        name: `Lenses of Figment Piercing`,
        longDesc: `When the wearer first sees an illusion effect with the figment subschool with a visual element, and that figment allows a saving throw, she can immediately make any allowed saving throw to realize the image is illusory instead of waiting to interact with it. This has no effect on illusions of other subschools or on illusions that do not normally allow a saving throw. If the wearer fails to disbelieve the illusion and later interacts with it in such a way as to qualify normally for a saving throw to disbelieve, she gains a +4 competence bonus on this saving throw.`,
        },
        {
        rarity: "epic",
        type: ["eyes"],
        name: `Arachnid Goggles`,
        longDesc: `When wearing these goggles, the wearer gainings the all-around vision monster ability which means you can no longer be flanked.`,
        },
        {
        rarity: "epic",
        type: ["eyes"],
        name: `Darksite Goggles`,
        longDesc: `Gain 120 feet of dark vision and a +5 bonus to perception checks`,
        },
        {
        rarity: "rare",
        type: ["eyes"],
        name: `Sniper Goggles`,
        longDesc: `The wearer of these goggles can make ranged sneak attacks from any distance instead of the normal 30 feet. When making ranged sneak attacks within 30 feet, the wearer gains a +2 circumstance bonus on each sneak attack damage die.`,
        },
        {
        rarity: "epic",
        type: ["eyes"],
        name: `Greater Sniper Goggles`,
        longDesc: `The wearer of these goggles can make ranged sneak attacks from any distance instead of the normal 30 feet, and the wearer gains a +2 circumstance bonus on each sneak attack damage die.`,
        },
        {
        rarity: "legendary",
        type: ["eyes"],
        name: `Eyes of Doom`,
        longDesc: `Once per day as a standard action you can activate these goggles to give you a gaze attack with a 30 foot range for 5 rounds. Every opponent within the range must make a will save (DC=your intimidation modifier) or be affected by the spell doom.`,
        },
        {
        rarity: "legendary",
        type: ["eyes"],
        name: `Eyes of Charming`,
        longDesc: `The wearer is able to use charm person (one target per round) merely by meeting a target's gaze (as if it was a gaze attack, but only on one target per round). Those targets failing a Will save (DC= diplomacy modifier)  are charmed as per the spell (Akashic Paths version)`,
        },
        {
        rarity: "legendary",
        type: ["eyes"],
        name: `Monocle of the Investigator`,
        longDesc: `Gain a +6 bonus to perception checks. Additionally, once per day as a swift action you can use the spell scrying (Akashic Paths version).`,
        },
        {
        rarity: "epic",
        type: ["eyes"],
        name: `Swordmaster's Blindfold`,
        longDesc: `When the wearer places the blindfold over their eyes, they becomes blinded, but gain blindsight within the reach of their melee weapon, or 5 feet if the wearer is not wielding a melee weapon. Furthermore, the wearer is under the effect of a constant locate weakness spell, but only when making melee attacks. You can raise this above your eyes as a swift action to see again, or place it over your eyes again swift action to blind yourself again.`,
        },
        {
        rarity: "epic",
        type: ["eyes"],
        name: `Mindmaster's Eyes`,
        longDesc: `On command as a standard action, the wearer can use charm monster (Will DC 19 to negate), or once per day the wearer can use dominate person (Will DC 20 to negate) instead.`,
        },
        {
        rarity: "legendary",
        type: ["eyes"],
        name: `Eyes of the Dragon`,
        longDesc: `These eyes grant the wearer darkvision 120 ft. and blindsense 60 ft. The wearer sees four times as well as a human in dim light and twice as well in normal light.`,
        },
        {
        rarity: "unique",
        type: ["eyes"],
        name: `Truesight Goggles`,
        longDesc: `These goggles, constructed of a pair of perfect prisms held in place by golden frames and affixed to the head by a black leather strap, grants the wearer true seeing continuously.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Boots of the Cat`,
        longDesc: `The boot's wearer always takes the minimum possible damage from falls (as if the GM had rolled a 1 on each die of damage incurred by the fall) and at the end of a fall always lands on his feet.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Daredevil Softpaws`,
        longDesc: `As a free action, the wearer can click her heels together to grant herself a +5 competence bonus on Acrobatics checks made to move through threatened squares or to move through an enemy's space without provoking attacks of opportunity for up to 6 rounds per day. The rounds need not be consecutive. Furthermore, anytime the wearer of the boots successfully moves though the space of an enemy without provoking an attack of opportunity, she gains a +2 bonus on attack rolls against that enemy until the end of her turn.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Feather Step Slippers`,
        longDesc: `Once per day as a standard action you can activate these slippers for 5 rounds, these fine silken slippers allow their wearer to ignore the adverse movement effects of difficult terrain as if subject to the feather step spell, including granting the ability to take 5-foot steps in difficult terrain.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Acrobat Slippers`,
        longDesc: `The wearer retains his Dexterity bonus to AC when climbing, running, or using the Acrobatics skill to move on narrow surfaces or uneven ground without falling. In addition, the wearer gains a +2 competence bonus to CMD against trip maneuvers and on Reflex saves to avoid falling (including falling prone).`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Boots of the Mire`,
        longDesc: `You can walk across water as long as it is shallower than 5 feet without it counting as difficult terrain, and avoid any negative effects from stepping on that water (only water). The boots grant him a +2 resistance bonus on all Fortitude saves made against poison and disease.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Burglar Boots`,
        longDesc: `They grant their wearer a +5 competence bonus on Perception checks to spot or locate traps and devices within 10 feet. Also gain a +4 bonus to reflex saves and armor class against mechanical and magical traps.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Greater Burglar Boots`,
        longDesc: `They grant their wearer a +10 competence bonus on Perception checks to spot or locate traps and devices within 10 feet. Also gain a +8 bonus to reflex saves and armor class against mechanical and magical traps.`,
        },
        {
        rarity: "common",
        type: ["feet"],
        name: `Sandals of Quick Reaction`,
        longDesc: `During a surprise round you can take an additional movement action (even if you could not normally act during the surprise round)`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Slippers of Spider Climbing`,
        longDesc: `When worn, a pair of these slippers enables movement on vertical surfaces or even upside down along ceilings, leaving the wearer's hands free. Her climb speed is 20 feet. Severely slippery surfaces—icy, oiled, or greased surfaces—make these slippers useless. The slippers can be used for 1 minute per day, split up as the wearer chooses.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Sandals of the Lightest Step`,
        longDesc: `In any round when the wearer has already moved at least 10 feet along the ground or another surface (not counting travel on a mount or vehicle), these boots can be activated as a swift action to give the wearer the ability to walk on air (as the air walk spell) until the end of the round. If the wearer hasn't reached a solid surface by the end of the round, she immediately falls back to the ground, taking any applicable falling damage. These sandals can be used up to 3 times per day.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Boots of Striding and Springing`,
        longDesc: `These boots increase the wearer's base land speed by 10 feet. In addition to this striding ability (considered an enhancement bonus), these boots allow the wearer to make great leaps. She can jump with a +5 competence bonus on Acrobatics checks.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Haunted Shoes`,
        longDesc: `Once per day, the wearer of these shoes can call forth 1d4 spirit servants to aid her. The spirit servants are invisible, mindless, shapeless beings that act as servants summoned by the unseen servant spell. The spirits return to the shoes after 1 minute has passed. The wearer can choose to dismiss one or more of the spirit servants early.
        
        Additionally once per day, the wearer can command the ghostly spirits inside her haunted shoes to emerge and swirl around her, making her difficult to target in combat. The wearer gains concealment (20% miss chance) for 3 minutes. The spirits cannot be harmed, but a true seeing spell ignores the concealment effect. The concealment effect cannot be activated while any of the spirits are currently being used as unseen servants.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Jaunt Boots`,
        longDesc: `Three times per day, as a move action, the wearer can move up to 15 feet (or her movement speed if it's less than 15 feet).
        This movement does not provoke attacks of opportunity.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Boots of Levitation`,
        longDesc: `On command, these boots allow the wearer to levitate as if she had cast levitate on herself.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Boots of Escape`,
        longDesc: `Once per day, when the wearer of the boots is grappled, pinned, or entangled, she may transfer herself to any spot within 30 feet as if using a dimension door spell.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Earth Root Boots`,
        longDesc: `The wearer gains a cumulative +1 circumstance bonus to her CMD (maximum of +10) for each round in a row she does not move from her space.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Nightmare Boots`,
        longDesc: `When the wearer runs or charges, smoke issues up from the boots, acting as concealment (20% miss chance) when the wearer provokes attacks of opportunity while making those actions. Secondly, three times per day, as a swift action, the wearer can make the boots smoke, which grants her concealment until the end of her turn. Lastly, once per day, when the wearer hits a creature with a melee attack, she can command the boots to ignite. When the boots ignite, all creatures within a 5-foot radius take 2d6 points of fire damage. A DC 13 Reflex saving throw halves the damage.`,
        },
        {
        rarity: "epic",
        type: ["feet"],
        name: `Tremor Boots`,
        longDesc: `These boots grant the wearer tremorsense 5 feet as long as he is standing on solid ground.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Boots of the Mastodon`,
        longDesc: `The boots are so large and cumbersome that their wearer takes a —2 penalty on Stealth checks, but gains a +2 enhancement bonus on overrun attempts and a +2 dodge bonus to AC while attempting an overrun combat maneuver. In addition, once per day the wearer can make a trample attack. Regardless of his actual size, the creature wearing the boots can trample creatures of size Large or smaller in his path. The trample attack deals 2d8+18 points of damage (Reflex DC 29 halves).`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Shoes of Lightning Leaping`,
        longDesc: `Once per day as a standard, a creature wearing these boots can transform into lightning and move up to 50 feet in a straight line, re-materializing at the far end of the lightning bolt. Creatures in the path of the lightning take 6d6 points of electricity damage and objects take damage as per the lightning bolt spell. If the lightning strikes an object or barrier and fails to burst through it, the creature wearing the boots appears next to the impacted object and is staggered for 1 round. Movement while in lightning form does not provoke attacks of opportunity.`,
        },
        {
        rarity: "epic",
        type: ["feet"],
        name: `Boots of Speed`,
        longDesc: `As a free action, the wearer of boots of speed can click her heels together, letting her act as though affected by a haste spell for up to 5 rounds each day. The haste effect's duration need not be consecutive rounds.`,
        },
        {
        rarity: "epic",
        type: ["feet"],
        name: `Winged Boots`,
        longDesc: `As a standard action your boots sprout wings at the heel and let the wearer fly, without having to maintain concentration, as if affected by a fly spell (including a +4 bonus on Fly skill checks). The wearer can fly twice per day for up to 5 rounds per flight.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Shoes of the Firewalker`,
        longDesc: `They grant the wearer fire resistance 10 and allow the wearer to walk atop lava and magma as if subject to the water walk spell.`,
        },
        {
        rarity: "epic",
        type: ["headband"],
        name: `Headband of Unshakable Resolve`,
        longDesc: `Gain a +2 enhancement bonus to wisdom and whenever the wearer suffers a fear effect, she may spend an immediate action to reduce the severity of the fear effect by one step. If the wearer would become panicked, she is instead frightened. If she would become frightened, she is instead shaken. If the wearer would become shaken, the effect is negated entirely. The wearer can use this ability up to three times per day.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Headband of Deathless Devotion`,
        longDesc: `The wearer gains a +2 morale bonus on stabilization checks and on saving throws against ongoing effects with recurring saves, such as diseases, poisons, or compulsions such as dominate person or hold person. This does not effect the initial save.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Phylactery of the Shepherd`,
        longDesc: `3 times per day you may expend a swift action to activate a perk that heals a single willing ally within 30 feet (but not yourself). This perk only affects the single target you choose even if it would normally affect more targets. This only works on perks, not perks that cast spells and you must expend the resources for activating that perk as normal. If the perk was normally a swift action, you can instead activate this as a free action, but only once per round.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Fortune's Favor`,
        longDesc: `This multicolored headband with beaded tassels tips luck in the wearer's favor. The wearer gains a +1 luck bonus on saving throws.
        \nAny effect that gives the wearer a luck bonus (such as a divine favor or prayer spell) or explicitly increases the wearer's good luck (such as a witch's fortune hex, the Luck domain's bit of luck domain power, and so on) have their luck bonus increased by 1 (except the luck bonus granted by this headband). If the luck based ability does not grant an actual luck bonus you gain a +1 to rolls modified by that luck ability. (such as gaining a +1 to the d20 rolls when using fortune hex to roll twice and take the higher result)`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Havoc`,
        longDesc: `Increase the morale bonus to your strength and constitution granted by your rage by 1, and once per day you can begin raging even if exhausted or fatigued. The penalty from fatigued or exhaused still continue for its normal duration.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Serpent's Band`,
        longDesc: `The wearer of this circlet gains a +2 insight bonus on saving throws against effects with the emotion descriptor, including fear effects.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Phylactery of Positive Channeling`,
        longDesc: `This item allows channelers of positive energy, lay on hands, or fevor, healing aura (hexes), to increase the amount of damage dealt to undead creatures and healing to living creatures by +2d6. This increase only affects the activation of an ability once even if you have two sources of the ability, but you do not need to expend the additional spell points for this extra 2d6 of healing.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Phylactery of Negative Channeling`,
        longDesc: `This item allows channelers of negative energy, touch of corruption, and siphon, to increase the amount of damage dealt to living creatures and healing to undead by +2d6. This increase only affects the activation of an ability once even if you have two sources of the ability, but you do not need to expend the additional spell points for this extra 2d6.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Veiled Eye`,
        longDesc: `When worn, the veiled eye has the same vision as the wearer (such as low-light vision, darkvision 60 ft., or the oracle's clouded vision curse). It grants the wearer no particular advantages so long as his original eyes continue to function normally. However, should his original eyes stop working, whether because of the wearer becoming blinded or even his own decision to close them, he can see through the veiled eye instead. When the wearer is using the veiled eye as his only vision source, he takes a —2 penalty on ranged attack rolls but gains a +2 insight bonus on saves against gaze attacks.`,
        },
        {
        rarity: "epic",
        type: ["headband"],
        name: `Band of the Stalwart Warrior`,
        longDesc: `This plain iron band protects its wearer from fear effects. Whenever the wearer suffers a fear effect, she is merely shaken (even if the effect would normally make the target frightened or panicked). Furthermore, the subject gains a +2 competence bonus on all Will saves against fear. If the wearer has the bravery class feature, she is considered four levels higher when determining that class feature's effect.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of the Ninjitsu`,
        longDesc: `This simple black cloth band focuses the wearer's ki, helping her use subtle misdirection against opponents in combat. The wearer gains a +2 competence bonus on Bluff checks made to feint and combat maneuver checks made to reposition, and once per day she can attempt a feint or reposition maneuver as a swift action. The wearer also gains a +2 insight bonus on attack rolls on sneak attacks and can sneak attack creatures with concealment or total concealment, though miss chances apply normally.`,
        },
        {
        rarity: "common",
        type: ["headband"],
        name: `Headband of Arcane Energy`,
        longDesc: `This headband has three swirling patterns of red, green, and blue crystals arching across its length. Three times per day as a swift action, its wearer can sacrifice a spell slot to create an offensive blast or defensive shield. The blast is a ranged touch attack with a range of 30 feet, which deals 1d6 points of energy damage (cold, electricity, or fire) per spell level sacrificed. The shield creates a swirling band of energy that lasts 1 round and gives the wearer a deflection bonus to AC equal to 2 + the level of the spell sacrificed.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Counterspelling`,
        longDesc: `This metal headband grants a +5 insight bonus on Spellcraft checks made to identify a spell as it is being cast and a +2 to dispel magic caster level checks. Furthermore, once per day the wearer can attempt to counter a spell by casting the appropriate spell as an immediate action instead of doing so with a readied action. The wearer must first identify the spell being cast before countering a spell with this headband.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Winter Wolf Headband`,
        longDesc: `Crafted of pale bone or silver, this headband features a snarling wolf's head centered on the wearer's forehead. The wearer gains cold resistance 10. In addition, once per day the wearer may breathe a 30-foot cone of cold that deals 10d6 points of cold damage (Reflex DC 18 for half).`,
        },
        {
        rarity: "legendary",
        type: ["headband"],
        name: `Headband of Mental Resilience`,
        longDesc: `Gain a +2 enhancement bonus to all mental stats. The headband also protects the wearer from effects that would damage his mental capacity. The wearer gains five temporary ability points, these points do not add to the wearer's ability scores and do not grant a bonus to any roll. Any damage or drain to a mental ability score (Intelligence, Wisdom, or Charisma) taken by the wearer is subtracted from these points first. Damage or drain in excess of the wearer's temporary ability points is applied to his current ability scores as normal. The wearer immediately loses all temporary ability points upon removing the headband. Temporary ability points that are lost to ability damage return after 24 hours. Ability points lost to ability drain are lost permanently.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Ki Focus`,
        longDesc: `Whenever the wearer spends spell points to make an additional attack when using flurry of blows, that attack roll gains a +2 insight bonus (+4 if the wearer is using a ki focus weapon with that attack). Furthermore, the wearer of a headband of ki focus is immune to the ninja's ki block trick or similar effects that block the wearer from using ki points.`,
        },
        {
        rarity: "rare",
        type: ["headband"],
        name: `Headband of Ponderous Recollection`,
        longDesc: `As a swift action two times per day, the wearer can call upon the headband to reveal the abilities and weaknesses of a creature within line of sight. The headband fills the wearer's mind with information as though the wearer had made a Knowledge check with a natural roll of a 5, adding her bonuses to the check as normal. At the start of her next turn, the wearer receives additional information as though she had made the check with a natural roll of 10. At the start of her turn after that, the wearer receives a final piece of information, treating her natural roll as 15.`,
        },
        {
        rarity: "common",
        type: ["untyped"],
        name: `Scabbard of Vigor`,
        longDesc: `Once per day, as part of the action of drawing forth the weapon held by the scabbard, the wearer can order it to endow the weapon with an enhancement bonus on attack and damage rolls. The duration of the effect depends on the desired enhancement bonus for the weapon.
        Bonus	Duration
        +4:	1 round
        +3:	3 rounds
        +2:	5 rounds
        +1:	10 rounds`,
        },
        {
        rarity: "rare",
        type: ["untyped"],
        name: `Knight's Pennon`,
        longDesc: `This Pennon can cast either protection from evil or heroism once per day. It is cast as a 6th level caster.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Armbands of the Brawler`,
        longDesc: `They grant their wearer a +2 competence bonus on grapple checks and checks to break a grapple.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Bracers of Armor +1`,
        longDesc: `These wrist guards increase your armor bonus by +1. This stacks with armor or clothing, but not both.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Bracers of Armor +2`,
        longDesc: `These wrist guards increase your armor bonus by +2. This stacks with armor or clothing, but not both.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Bracers of Armor +3`,
        longDesc: `These wrist guards increase your armor bonus by +3. This stacks with armor or clothing, but not both.`,
        },
        {
        rarity: "legendary",
        type: ["wrist"],
        name: `Bracers of Armor +5`,
        longDesc: `These wrist guards increase your armor bonus by +5. This stacks with armor or clothing, but not both.`,
        },
        {
        rarity: "unique",
        type: ["wrist"],
        name: `Bracers of Armor +7`,
        longDesc: `These wrist guards increase your armor bonus by +7. This stacks with armor or clothing, but not both.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Bracers of Falcon's Aim`,
        longDesc: `Once per day as a standard action the wearer gains the benefits of aspect of the falcon spell for 1 minute.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Lesser Bracers of Archery`,
        longDesc: `Gain a +1 competence bonus to ranged attacks and damage with bows and crossbows. Additionally, when firing a bow or crossbow at a target enganged in melee you only get a -2 penalty instead of a -4.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Bracers of Archery`,
        longDesc: `Gain a +2 competence bonus to ranged attacks and damage with bows and crossbows. Additionally, when firing a bow or crossbow at a target enganged in melee you do not take the -4 penalty to attack for it.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Greater Bracers of Archery`,
        longDesc: `Gain a +3 competence bonus to ranged attacks and damage with bows and crossbows. Additionally, you reduce the armor class bonus the target receives from cover by 1 and when firing a bow or crossbow at a target enganged in melee you do not take the -4 penalty to attack.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Spellguard Bracers`,
        longDesc: `The bracers grant the wearer a +2 bonus on concentration checks made to cast defensively. Twice per day the wearer can choose to roll a concentration check to cast defensively twice and take the better result.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Bonebreaker Bracers`,
        longDesc: `Once per day as part of a melee attack, the wearer can activate the bracers to inflict a horrific injury on an opponent. If the attack hits, the target must make a DC 12+bab/2 Will save. If the save fails, the bracers reduce the target's Strength, Dexterity, or Constitution (wearer's choice) by -6. This penalty cannot reduce the target's ability score below 1. The injury heals over time, reducing the penalty by 1 for each day that passes since the time of the injury, and is immediately removed by heal, regenerate, restoration, or any magic that can break a curse.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Vambraces of Defense`,
        longDesc: `These polished steel vambraces grant a +1 deflection bonus to AC. Once per day, as an immediate action, if the wearer has at least one hand free, when he would normally be hit with an attack from a ranged weapon, he may deflect it with the bracers, taking no damage from it, as if he had the Deflect Arrows feat.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Longarm Bracers`,
        longDesc: `Three times per day, as a swift action, the wearer can stretch her arms beyond their limits, increasing her reach by 5 feet until the start of her next turn. Her weapon attack rolls take a —4 penalty, while unarmed strikes and natural weapons using the arms take no penalty.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Duelist's Vambraces`,
        longDesc: `these vambraces grant a +1 deflection bonus to AC while the wearer is wielding a double weapon or two weapons (not including natural weapons or unarmed attacks). In addition, once per round, when attacking with an off-handed weapon, the wearer can gain a +2 bonus to the attack roll.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Merciful Vambraces`,
        longDesc: `Once per day, when the using a healing spell with a range of touch, you can cause the creature healed to be able to reroll a save for a condition currently affecting them. If this roll succeeds the effect ends.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Seducer's Bane Bracelet`,
        longDesc: `The bracelet grants the wearer a +5 competence bonus on Sense Motive checks, and a +5 resistance bonus on Will saves against enchantment effects. If the wearer makes a successful Will save against an enchantment, the caster of that spell incorrectly senses the effect has succeeded. Additionally, the bracelet's wearer knows an enchantment targeted him and the enchantment's source. Seducer's bane creates an aura on its wearer, visible to detect magic, matching the failed enchantment spell or effect, and lasting as long as the intended enchantment's duration. However, if the bracelet's wearer attacks the caster or its allies, or otherwise acts in a way that's contradictory to the failed spell's effect, the caster of that spell immediately realizes the enchantment was ineffective.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Bracers of the Avenging Knight`,
        longDesc: `Once per day when making an attack you can activate these bracers to gain a bonus to your attack roll equal to your highest mental stat, a bonus to damage equal to your level, and bypassing all DR. These bonuses stack with all other bonuses, even smite.`,
        },
        {
        rarity: "common",
        type: ["wrist"],
        name: `Arrowmaster's Bracers`,
        longDesc: `The wearer of these bracers gains damage reduction 5/magic against ranged weapons, as well as a +1 deflection bonus against ranged attacks. In addition, once per day, as a swift action, the wearer can grant herself a +20 insight bonus on her next ranged attack roll before the end of her next turn.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Bracers of the Merciful Knight`,
        longDesc: `When using lay on hands, channel energy or a healing hex, you are considered four levels higher for the purposes of determining the healing provided by these abilities. Additionally, once per day, the wearer can infuse a use of the ability with additional power, providing relief as a lesser restoration spell.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Bracelet of Second Chances`,
        longDesc: `When a critical hit or sneak attack is confirmed on the wearer, as an immediate action before the damage is rolled, he can choose to convert the critical hit into a normal hit. Each time the wearer negates a critical hit or sneak attack in this manner, one bead shatters. When all seven are used up, the bracelet itself crumbles into powder.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Bracelet of Friends`,
        longDesc: `Once per day as a standard action you can activate this bracelet to teleport all party members to squares adjacent to you. All party members must be willing for this ability to activate, you cannot summon only specific party members. If an ally is unconcious they do not need to consent and are automatically teleported.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Bracers of Sworn Vengeance`,
        longDesc: `Once per day, as an immediate action when the wearer takes hit point damage from a target, he may cry out, “Death to those who wrong me!”, swearing vengeance against the attacker. The wearer gains a +1 competence bonus on weapon attack rolls made against the target of his sworn vengeance, and deals an additional 2d6 points of damage on successful weapon attack rolls.
        
        For the duration of the effect, the wearer takes a -2 penalty on attack rolls against any target other than his sworn enemy.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Gauntlets of Skill at Arms`,
        longDesc: `Gain a +2 competence bonus on attack and damage rolls with manufactored weapon attacks.`,
        },
        {
        rarity: "rare",
        type: ["wrist"],
        name: `Inquisitor's Bastion`,
        longDesc: `While using the smite or judgement perks to gain a bonus to armor class or saves, increase the bonus by +1.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Catching Cape`,
        longDesc: `Once per day as a swift action, the wearer can order the cape to transform into a faint sphere of force that surrounds him on all sides. The field grants the wearer concealment (20% miss chance) against ranged attacks and lasts for 1 minute or until the wearer is missed by a ranged attack due to the power of the cloak, whichever comes first. `,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Muleback Cords`,
        longDesc: `Gain a +5 bonus to checks to lift heavy objects. If you are wearing medium or heavy armor that reduces your movement speed, reduce the penalty to your movement speed by 5 feet.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Shawl of Life-Keeping`,
        longDesc: `Once per day, if you are reduced below 0 hitpoints the shawl activates and you gain 10 temporary hit points. At the end of each of your turns reduce the temporary hit points granted by this item by 2 until none is left.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Shield Cloak`,
        longDesc: `The wearer of this rough, gray cloak can, as a swift action, grasp the garment's edge and cause it to harden. The wearer can use the hardened edge it as if it were a masterwork light wooden shield which grants a +2 shield bonus to armor class. Using the cloak in this fashion imposes no armor check penalty. The edge of the cloak can be dropped and made pliant again as a free action.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cowardly Crouching Cloak`,
        longDesc: `The wearer can, as a move action, cover his face and drop to a huddling crouch. Any creature seeking to directly attack him while he does this must make a (DC=diplomacy modifier) Will save to do so (as the sanctuary spell). The wearer cannot see or take any actions while crouching. This makes him effectively blind, with all the normal penalties, but not helpless. The wearer can end his crouch simply by standing up or moving.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of Fiery Vanishing`,
        longDesc: `Once per day, when subject to an effect that deals fire damage, the wearer can spend an immediate action while obscured by the flames to become invisible, leaving behind an illusory pile of ashes and bones, as if he had been slain by the fire effect. The wearer's invisibility and his illusory remains last for 5 rounds or until the wearer attacks any creature. Creatures that study or interact with the ashes can make a DC 11 Will save to disbelieve the illusion, though this does not end the invisibility effect.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of Fangs`,
        longDesc: `Wearing this animal-hair cloak grants a +1 resistance bonus on saving throws. Furthermore, the wearer can force its teeth to grow rapidly up to five times per day as a swift action. The oversized teeth last for 1 round, during which time the wearer can make a bite attack. Treat this attack as a primary natural attack that deals 1d6 points of damage (or 1d4 if the wearer is Small). If the wearer already has a bite attack, the damage of that bite attack increases by one step.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Pauldrons of the Serpent`,
        longDesc: `These pauldrons grant their wearer a +2 dodge bonus to AC against attacks of opportunity, and increase the wearer's CMD by 2 against bull rush, grapple, reposition, and trip combat maneuvers.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Stonemist Cloak`,
        longDesc: `When this stone-gray cloak is worn with the hood drawn up around the head, the wearer gains a +5 competence bonus on Stealth checks. Once per day, the wearer can create an area of fog equivalent to obscuring mist at caster level 3`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Seafoam Shawl`,
        longDesc: `This shawl of delicate lace can be activated once per day to grant the benefits of the fins to feet spell, transforming the wearer's lower fins or appendages into feet whenever he is on dry land—unless dismissed, this effect lasts for 5 hours. (caster level 5)`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Eagle Cape`,
        longDesc: `Should the cape's wearer fall more than 5 feet, the cape spreads out behind the wearer and she gently drifts to the ground. This acts exactly like a feather fall spell for the wearer only. Once per day, if the wearer grasps the edges of the cape and spreads her arms, she transforms into an eagle (as per the beast shape I spell, except that it allows only eagle form and the wearer gains the eagle's full fly speed of 80 feet). This effect lasts for 1 minutes but can be ended prematurely as a standard action. In addition, while in eagle form, the wearer gains a +5 competence bonus on Perception checks.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of the Manta Ray`,
        longDesc: `Once per day as a standard action, the wearer can transform into a manta ray (as the beast shape II spell, except that it allows only manta ray form). While transformed he gains a +3 natural armor bonus, the ability to breathe underwater, and a swim speed of 60 feet, like a real manta ray.
        
        The cloak does allow the wearer to attack with a manta ray‘s tail spine, dealing 1d6 points of damage. This attack can be used in addition to any other attack the character has, using his highest melee attack bonus. The wearer can release his arms from the cloak without sacrificing underwater movement if so desired.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of the Dusk Walker`,
        longDesc: `The cloak grants its wearer low-light vision.
        
        In addition, once per day, on command, the wearer can surround herself with darkness, as the darkness spell (CL 3). While this darkness is active, the cloak also grants the wearer darkvision 60 feet as well as low-light vision.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Cocoon Cloak`,
        longDesc: `Anytime the wearer falls asleep (whether the sleep is natural or brought on by a magical effect), the cloak immediately transforms into sticky strands that envelop the wearer's body, hardening into a solid silk cocoon. While wrapped in the cocoon the wearer gains a +4 enhancement bonus to natural armor and is protected from critical hits and sneak attacks as if subject to the light fortification armor ability (25% chance for normal damage on a critical hit). The cocoon opens and transforms back into a cloak once the wearer awakens.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Pauldrons of the Bull`,
        longDesc: `When the wearer makes a bull rush combat maneuver, she can make the check twice and take the better result. Furthermore, they grant a +2 enhancement bonus to CMD against bull rushes.`,
        },
        {
        rarity: "common",
        type: ["shoulders"],
        name: `Lesser Stone Cloak`,
        longDesc: `The wearer can pull a minor stone cloak tight around herself and freeze in place as a move action, which causes the cloak to harden like the stone it resembles. When she does this, the wearer can take no actions other than free actions and is denied her Dexterity bonus to AC but gains DR 5/adamantine. She also gains a +5 circumstance bonus to Stealth checks while protected in this manner. This effect can be dismissed as a free action.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Stone Cloak`,
        longDesc: `This mottled gray cloak looks like granite or some other light gray stone. The wearer can pull a minor stone cloak tight around herself and freeze in place as a move action, which causes the cloak to harden like the stone it resembles. When she does this, the wearer can take no actions other than free actions and is denied her Dexterity bonus to AC but gains DR 10/adamantine. She also gains a +5 circumstance bonus to Stealth checks while protected in this manner. This effect can be dismissed as a free action.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Greater Stone Cloak`,
        longDesc: `This mottled gray cloak looks like granite or some other light gray stone. The wearer can pull a minor stone cloak tight around herself and freeze in place as a swift action, which causes the cloak to harden like the stone it resembles. When she does this, the wearer can take no actions other than free actions and is denied her Dexterity bonus to AC but gains DR 10/adamantine. She also gains a +10 circumstance bonus to Stealth checks while protected in this manner. This effect can be dismissed as a free action.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cape of the Mountebank`,
        longDesc: `Once per day on command, this bright red and gold cape allows the wearer to use the magic of the dimension door spell (CL 9). When he disappears, he leaves behind a cloud of harmless gray smoke, appearing in a similar fashion at his destination.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Mantle of Spores`,
        longDesc: `This mantle grants the wearer a +4 resistance bonus on saving throws against disease. Once per day, the wearer can flourish the cape as a swift action to surround himself with a cloud of deadly spores. Creatures adjacent to the wearer take 1d6 points of damage from the spores, plus 1d3 points of damage per round for 3 rounds as the spores grow into fuzzy green mold. After these rounds the mold becomes harmless, and can be washed away with a minute of scrubbing. The spores can be destroyed by making a DC 15 Heal check on an affected creature, or by effects that remove diseases. The spores are a disease effect.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cape of Effulgent Escape`,
        longDesc: `This shining white cloak is trimmed with golden sunbursts and continuously radiates light (as per the light spell, but only in a 10-foot radius). Twice per day, the wearer can command the cape to erupt in a burst of light, blinding all creatures other than the wearer within 20 feet for 1d4 rounds (Reflex DC 14 negates). After triggering this burst, the wearer becomes invisible (as the invisibility spell, with a duration of 1 minute) and the cape's light is extinguished as long as the wearer is invisible. (CL 3)`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cloak of Arachnida`,
        longDesc: `This cloak gives the wearer the ability to climb as if a spider climb spell had been placed upon her. In addition, the cloak grants her immunity to entrapment by web spells or webs of any sort; she can move in webs at half her normal speed. Once per day, the wearer of this cloak can cast web. She also gains a +2 luck bonus on all Fortitude saves against poison from spiders.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Gunfighter's Poncho`,
        longDesc: `The wearer gains a +2 luck bonus to touch AC. Once per day as an immediate action, the wearer can negate a single ranged touch attack targeted at him, but cannot use this ability if the attack is a confirmed critical hit. When the wearer uses this ability, he must fall prone.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Tentacle Cloak`,
        longDesc: `Once per day at the wearer's command, two large gray tentacles emerge from the cloak near the shoulders. Each tentacle can make a natural attack that deals 1d6 points of bludgeoning damage, assuming the wear is Medium (the damage of the tentacles scales by size of the wearer as a tentacle natural attack). The tentacles have 10-foot reach and the grab monster special ability. In addition, the wearer gains a +4 competence bonus on grapple maneuver checks with the tentacles. The tentacles last for 1 minute.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Demonspike Paldrons`,
        longDesc: `Whenever you grapple or are grappled by a creature it takes 1d2 points of bleed damage.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Comfort's Cloak`,
        longDesc: `Comfort's cloak grants a 5 fire and cold resistance, a +4 competence bonus to saves against disease, energy drain, effects that cause fatigue or exhaustion, and poisons. Lastly while descending a floor you heal your level hit points.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Stole of Justice`,
        longDesc: `This long stole of unrelenting black is marked on one end with golden scales and the other with the embroidered image of hooded justice. While worn by a good character your weapon attacks deal an additional 1d6 points of damage to evil creatures, and your weapon counts as good for bypassing DR. You gain a +2 morale bonus to will saves against compulsions cast by evil creatures.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Jellyfish Cape`,
        longDesc: `This billowing white cape renders the wearer almost invisible the moment she is submerged in salt water, granting her concealment (20% miss chance) so long as she remains entirely submerged. The wearer can breathe underwater and gains a swim speed of 20 ft. While the wearer is submerged, the cape surrounds her with tiny stinging tentacles. Any creature that ends its turn adjacent to the wearer takes 1 point of electricity damage and must succeed at a DC 16 Fortitude saving throw or be sickened for 1 round. The sickened effect is a poison effect.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Cloak of the Diplomat`,
        longDesc: `The forest-green cloak grants a +5 competence bonus on Diplomacy and Sense Motive checks. In addition, once per day, before making a Diplomacy or Sense Motive check, the wearer can decide to call upon the powers of the cloak to roll twice and take the better result.`,
        },
        {
        rarity: "rare",
        type: ["shoulders"],
        name: `Slashing Cape`,
        longDesc: `This thick burgundy cloak is trimmed with mithral plates and cut to fit handsomely over heavy armor. As a full-round action, the wearer can spin in his space, damaging each creature within 5 feet. This attack uses the wearer's highest base attack bonus against each creature, and deals 2d6 damage on a hit. The wearer is considered proficient with this attack. This counts as light weapon and can have bonuses added to it, but this attack does not add any ability score to its damage.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cloak of Displacement`,
        longDesc: `On command its magical properties distort and warp light waves. This displacement works just like the displacement spell and lasts for a total of 8 rounds per day, which the wearer can divide up as she sees fit.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Blurry Cloak`,
        longDesc: `While worn this cloak continually provides the benefit of the blur spell, granting a 20% miss chance. (CL 3)`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cloak of the Bat`,
        longDesc: `Fashioned of dark brown or black cloth, this cloak bestows a +5 competence bonus on Stealth checks. The wearer is also able to hang upside down from the ceiling like a bat.
        
        By holding the edges of the garment (using two hands), the wearer is able to fly as per the spell (including a +7 bonus on Fly skill checks). If he desires, the wearer can actually polymorph himself into an ordinary bat and fly accordingly (as beast shape III). All possessions worn or carried are part of the transformation. Flying, either with the cloak or in bat form, can be accomplished only in darkness (either under the night sky or in a lightless or near-lightless environment underground). Either of the flying powers is usable for up to 7 rounds at a time, but after a flight of any duration the cloak cannot bestow any flying power for a like period of time.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Highwayman's Cape`,
        longDesc: `This reversible multicolored cape marks the wearer's flamboyant audacity when turned with its bright colors outward, granting a +5 competence bonus on Bluff checks. Reversible as a move action, the dappled camouflage of its other side grants a +5 competence bonus on Stealth checks. Regardless of the cape's current facing, the wearer can spend an immediate action at will to roll an Escape Artist check against being grappled, bound, or restrained as if the cape targeted her with liberating command. (CL 5)`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Juggernaut's Pauldrons`,
        longDesc: `These massive pauldrons take the shape of a pair of clenched fists made of beaten bronze. They bestow a +4 bonus on CMD, and grant the wearer the ferocity ability. On command, the wearer can increase its size, as though subject to an enlarge person spell, and can revert to regular size with another command. Three times per day, as an immediate action after the pauldrons' wearer kills an opponent, the wearer gains the benefit of the deadly juggernaut spell for 4 rounds. If you reactivate the deadly juggernaut ability after getting a kill while deadly juggernaut was still active it extends the duration by 4 rounds instead of restarting it.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Wings of Flying`,
        longDesc: `A pair of these wings might appear to be nothing more than a plain cloak of old, black cloth, or they could be as elegant as a long cape of blue feathers.
        
        When the wearer speaks the command word (standard), the cloak turns into a pair of bat or bird wings that empower her to fly with a speed of 60 feet (average maneuverability), also granting a +5 competence bonus on Fly skill checks.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Cloak of Etherealness`,
        longDesc: `This silvery gray cloak seems to absorb light rather than be illuminated by it. On command, the cloak makes its wearer ethereal (as the ethereal jaunt spell). The effect is dismissible as a standard action.
        
        The cloak works for a total of up to 1 minute per day. This duration need not be continuous, but it must be used in 3 round increments. If you dismiss it before 3 rounds has been used the remaining rounds up to 3 are lost.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Wings of the Gargoyle`,
        longDesc: `These cloth shoulder straps have many pebbles stitched into them. The wearer of the straps can command them to unfurl a pair of wings made from a hard gray stone. These wings grant her a fly speed of 60 feet and average maneuverability. When these wings are present her skin also takes on a noticeable stone-like appearance and she gains DR 10/adamantine. The wearer can furl and unfurl these wings as a swift action. The wings can be used for up to 2 minutes each day. The duration need not be continuous, but it must be used in 1-minute increments.`,
        },
        {
        rarity: "legendary",
        type: ["shoulders"],
        name: `Wyvern Cloak`,
        longDesc: `This heavy cloak is made of blue scaled leather and has a pointed hem that hangs near the ground. The cloak provides the wearer a +4 resistance bonus on Will saves, a continuous feather fall effect (as the spell), and the ability to use fly once per day. At will as a swift action, the wearer can form the hem into a stinger, granting her a sting natural weapon. This sting deals 1d6 points of damage plus poison (as the spell; DC 16). Reverting the stinger to its normal, inconspicuous shape is a free action.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Aegis of Recovery`,
        longDesc: `An aegis of recovery grants its wearer a +2 resistance bonus on all saving throws made to recover from a continuing effect, such as ongoing poison damage, daily saving throws against disease, a hold person spell, or lingering damage from an attack. This bonus does not help against initial saving throws against such effects. Should the wearer ever drop below 0 hit points, the aegis heals the wearer for 2d8+3 points of damage and then crumbles to dust.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Greater Aegis of Recovery`,
        longDesc: `A greater aegis of recovery grants its wearer a +5 resistance bonus on all saving throws made to recover from a continuing effect, such as ongoing poison damage, daily saving throws against disease, a hold person spell, or lingering damage from an attack. This bonus does not help against initial saving throws against such effects. Should the wearer ever drop below 0 hit points, the aegis heals the wearer for 5d8+7 points of damage and then crumbles to dust.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Swarmbane Clasp`,
        longDesc: `An ancient fossilized insect lies trapped within this ornate amber clasp, impaled by the long golden pin that fastens the wearer's cloak. The wearer's weapons, unarmed attacks, and natural attacks deal full damage to swarms, regardless of the swarm's immunity to weapon damage (if any, although damage reduction applies as normal). If the wearer is damaged by a swarm, she automatically succeeds on her saving throw against the swarm's distraction ability.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Mind Sentinel Medallion`,
        longDesc: `The medallion grants a continuous +2 resistance bonus on saves versus mind-affecting spells, spell-like abilities , and supernatural abilities. If the wearer fails a save to avoid becoming dominated or confused, the amulet immediately grants the wearer a second saving throw to resist the effect. If this second save is successful, the medallion's power fades away entirely and it becomes a simple piece of silver jewelry.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Amulet of Elemental Strife`,
        longDesc: `The wearer gains resistance 5 against a single energy type determined by the subtype of the closest elemental present (air grants electricity resistance, earth grants acid resistance, fire grants fire resistance, and water grants cold resistance). If the closest elemental possesses multiple subtypes, the wearer may choose which type of resistance she gains. This energy resistance only applies against attacks from elementals. The amulet also allows any attacks made by the wearer to bypass the damage reduction of such creatures.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Stormlure`,
        longDesc: `Once per day on command (standard), the wearer of a stormlure is surrounding by swirling winds for 5 rounds, granting a 50% miss chance against all ranged attacks, including rays and other ranged spells that require a roll to hit. This wind does not hinder the wearer of the stormlure in any way. At any one time during this duration, as a swift action, the wearer can cause the air around her to fill with crackling lightning, dealing 4d6 points of electricity damage to all creatures adjacent to her. A DC 14 Reflex save halves this damage.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Carcanet of Detention`,
        longDesc: `Once per day, the wearer of the carcanet may command (standard) it to animate and attempt to wrap around one Medium or smaller creature within 15 feet. The target receives a DC 15 Reflex saving throw to avoid the chain. If the saving throw fails, the target is entangled and cannot move from its current location. As a full-round action, the target can attempt a new saving throw to end the effect; otherwise it persists for 10 minutes or until ended by the wearer as a swift action, at which point it returns to its carcanet form. The chain has a hardness of 10 and 15 hit points.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Periapt of Health`,
        longDesc: `The wearer is immune to all disease, including supernatural diseases.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Amulet of Proof Against Petrification`,
        longDesc: `This finely polished wooden amulet has the image of a blindfolded medusa carved upon its surface. Whenever the wearer fails a saving throw that would result in him being turned to stone, he is instead staggered for 1d6 rounds. If a spell or effect turns him to stone without allowing a saving throw, he is instead staggered for 1 minute. These abilities do not function while the wearer is staggered.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Gravewatch Pendant`,
        longDesc: `This amulet emits a soft blue light. Undead creatures are repulsed by this light and take a —2 penalty on all attack rolls against the wearer of a gravewatch pendant. Incorporeal undead creatures are further repulsed and instead take a —4 penalty on all attack rolls against the wearer. Undead creatures can sense this light easily, however, and receive a +4 circumstance bonus on Perception checks to detect a creature wearing this pendant.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Torc of Lionheart Fury`,
        longDesc: `The wearer gains a +4 morale bonus on saving throws against fear. If raging you become immune to the shaken and frightened condition, if at least level 10 you also become immune to the panicked condition.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Amulet of Hidden Strength`,
        longDesc: `This glass teardrop hangs on a platinum chain and can be used once per day to grant a surge of power. This surge can be used in one of two ways. As a swift action, the wearer of the amulet can make one melee or ranged attack at his highest attack bonus. Alternatively, he can instead focus on the power of the amulet as a full-round action and regain level x2 spell points.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Greater Amulet of Hidden Strength`,
        longDesc: `This glass teardrop hangs on a platinum chain and can be used three times per day to grant a surge of power. This surge can be used in one of two ways. As a swift action, the wearer of the amulet can make one melee or ranged attack at his highest attack bonus. Alternatively, he can instead focus on the power of the amulet as a full-round action and regain level x2 spell points.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Necklace of Adaptation`,
        longDesc: `The magic of the necklace wraps the wearer in a shell of fresh air, making him immune to all harmful vapors and gases (such as cloudkill and stinking cloud effects, as well as inhaled poisons) and allowing him to breathe, even underwater or in a vacuum.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Amulet of Spell Cunning`,
        longDesc: `The first 2 spells you cast each day cost 0 spell points. This only affects the spell and not modifiers to the spell such as metamagic feats, and cost spell points as if the spell had not had its spell point cost reduced to zero.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Amulet of the Battle Spirits`,
        longDesc: `Once per day as a swift action, the wearer can activate a battle ward, which grants her a +3 deflection bonus to AC. Each time she is attacked, the deflection bonus is reduced by 1 (whether the attack succeeds or not) until the ward fades away when the bonus reaches +0. In addition, once per day as a swift action the wearer can curse a creature within 30 feet, making it take more damage from bleed effects and causing its wounds to heal at a slower rate. When the cursed creature takes bleed damage, it takes 1 additional point of bleed damage (even if the bleed is ability damage). Furthermore, when the target is subject to an effect that would restore its hit points, that effect restores only half the normal amount of hit points. This curse lasts for 8 rounds.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Bone Spirits`,
            longDesc: `Once per day as a swift action, the wearer can activate a bone ward, which causes a group of flying bones to encircle her, granting her a +2 deflection bonus to AC for 8 rounds. In addition, once per day as a swift action the wearer can target a creature within 30 feet, causing it to become frightened for 1 round (Will DC 10+charisma modifier negates).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Heaven Spirits`,
            longDesc: `You can add your Wisdom modifier to your Charisma modifier on all Charisma checks and Charisma-based skill checks. In addition, as a standard action the wearer can cause one enemy within 30 feet to treat the light level as two steps lower: bright light becomes dim light, normal light becomes darkness, and areas of dim light and darkness become supernaturally dark (like darkness, but even creatures with darkvision can't see). This effect lasts for 8 rounds (Will DC 10+wisdom mod negates). This action doesn't provoke attacks of opportunity.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Life Spirits`,
            longDesc: `The wearer becomes more receptive to healing magic, regaining an additional 1d6 hit points from any conjuration(healing) spell cast upon them. In addition, once per day as a standard action, the wearer can cut off any single creature within 30 feet from all forms of magical healing and effects that remove conditions. A DC 10+wisdom moifier Will saving throw negates this effect, which otherwise lasts for 1 minute.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Stone Spirits`,
            longDesc: `Once per day as a swift action, the wearer can activate a ward of stone, granting herself DR 5/adamantine against the next two melee attacks against her. This ward lasts for 1 minute, after which it fades away if not expended. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to become slightly magnetic; this effect lasts for 2 rounds. Whenever the creature is attacked by a melee or ranged weapon made primarily of metal, it takes a -4 penalty to AC.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Wave Spirits`,
            longDesc: `Once per day as a swift action, the wearer can activate a ward of mist, granting herself concealment as the blur spell. The mist dissipates after it causes two attacks to miss because of concealment or after 1 minute, whichever comes first. In addition, as a swift action once per day the wearer can cause one creature within 30 feet to become more susceptible to the sapping powers of cold for 1 minute. When a creature takes cold damage while under this effect, it is entangled for 1 round. If the creature takes cold damage while already entangled by this effect, the duration of the entangled condition increases by 1 round.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Amulet of the Wind Spirits`,
            longDesc: `Once per day as a swift action, the wearer can activate a ward of wind that lasts for 1 minute. When she is attacked with an arrow, ray, or other ranged attack that requires an attack roll, that attack roll has a 20% miss chance. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to spark and shimmer with electrical energy. While this does not harm the creature, it does cause the creature to emit light like a torch, preventing it from gaining any benefit from concealment or invisibility. Furthermore, while the aura lasts, whenever the target is hit with a metal melee weapon, it also takes 5 points of electricity damage. The sparking aura lasts 4 rounds.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of the Flame Spirits`,
            longDesc: `Twice per day as a swift action, the wearer can activate a fire ward. The next time she is struck with a melee weapon, the creature making the attack takes 1d6+4 points of fire damage. The ward lasts for 1 minute, after which it fades away if not expended. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to become vulnerable to fire until the end of the wearer's turn. Whenever the creature takes fire damage, it takes half again as much damage (+50%). If the creature is already vulnerable to fire, this hex has no effect. Fire immunity and resistances apply as normal, and any saving throw allowed by the effect that caused the damage reduces it as normal.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of the Frost Spirits`,
            longDesc: `Twice per day as a swift action, the wearer can activate a ice ward. The next time she is struck with a melee weapon, the creature making the attack takes 1d6+4 points of cold damage. The ward lasts for 1 minute, after which it fades away if not expended. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to become vulnerable to cold until the end of the wearer's turn. Whenever the creature takes cold damage, it takes half again as much damage (+50%). If the creature is already vulnerable to cold, this hex has no effect. cCld immunity and resistances apply as normal, and any saving throw allowed by the effect that caused the damage reduces it as normal.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of the Earth Spirits`,
            longDesc: `Twice per day as a swift action, the wearer can activate a earth ward. The next time she is struck with a melee weapon, the creature making the attack takes 1d6+4 points of acid damage. The ward lasts for 1 minute, after which it fades away if not expended. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to become vulnerable to acid until the end of the wearer's turn. Whenever the creature takes acid damage, it takes half again as much damage (+50%). If the creature is already vulnerable to acid, this hex has no effect. Acid immunity and resistances apply as normal, and any saving throw allowed by the effect that caused the damage reduces it as normal.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of the Sky Spirits`,
            longDesc: `Twice per day as a swift action, the wearer can activate a electricity ward. The next time she is struck with a melee weapon, the creature making the attack takes 1d6+4 points of electricity damage. The ward lasts for 1 minute, after which it fades away if not expended. In addition, once per day as a swift action the wearer can cause a creature within 30 feet to become vulnerable to electricity until the end of the wearer's turn. Whenever the creature takes electricity damage, it takes half again as much damage (+50%). If the creature is already vulnerable to electricity, this hex has no effect. Electricity immunity and resistances apply as normal, and any saving throw allowed by the effect that caused the damage reduces it as normal.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Frost Fist Amulet`,
        longDesc: `On command (standard action), this amulet causes the wearer's hands to become encased in a layer of freezing iron. The wearer is protected from the frigid cold and can make savage blows with his hands. Unarmed strikes and natural attacks the wearer makes with hands gain the frost weapon special ability and are treated as cold iron for the purpose of bypassing damage reduction. The wearer's hands become rigid while using this amulet and cannot be use to hold or manipulate objects (unless that manipulation could be accomplished with a club and is not damaged by cold). The transformation can be ended as a swift action.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Crystal of Healing Hands`,
        longDesc: `Once per day the wearer of this amulet can use their lay on hands or fervor ability as a free action, their channel, or healing hex, as a swift action, or their soothing performance as a movement action.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Periapt of Protection from Curses`,
        longDesc: `Twice per day, whenever the wearer rolls a saving throw against a curse (such as a witch's hex, or a bestow curse spell), he may reroll the saving throw as an immediate action. The wearer must decide to use this ability before the results of the saving throw are revealed. He must take the second roll, even if it is worse.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Forge Fist Amulet`,
        longDesc: `On command (standard action), this amulet causes the wearer's fists to transform into red-hot flaming adamantine. The wearer is protected from the searing heat and can make savage blows with his hands. Unarmed strikes and natural attacks the wearer make with his hands gain the flaming weapon special ability and are treated as adamantine for the purpose of bypassing damage reduction (but not hardness). The wearer's hands become rigid while using this amulet and cannot be use to hold or manipulate objects (unless that manipulation could be accomplished with a club and is not damaged by fire). The transformation can be ended as a swift action.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Periapt of Wound Closure`,
        longDesc: `The wearer of this periapt automatically becomes stable if his hit points drop below 0 (but not if the damage is enough to kill the wearer).  Hit point damage caused by bleeding is negated for the wearer of the periapt, but he is still susceptible to damage from bleeding that causes ability damage or drain.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Brooch of Amber Sparks`,
        longDesc: `This copper clasp adorned with a piece of amber is used to fasten a cloak or cape. When its wearer takes electricity damage, this brooch absorbs up to 20 points of electrical damage and holds that electrical charge until it is released by its wielder or harmlessly at the end of 10 minutes, whichever occurs first. The brooch can absorb up to 50 points of electricity damage per day. The wielder can release the charge as a free action while making an attack with a melee weapon, or a touch attack, unleashing any electricity in the brooch as if casting a shocking grasp spell (dealing 1d6 points of electricity damage per 5 points of damage held).`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Symbol of Sanguine Protection`,
        longDesc: `Undead creatures and evil outsiders that successfully use a blood drain attack on the wearer take 4d6 points of positive energy damage and are sickened for 1d4 rounds unless they make a DC 16 Will save. Any benefit the creature might gain from drinking the wearer's blood is negated due to the power of this symbol.`,
        },
        {
        rarity: "rare",
        type: ["neck"],
        name: `Dragonfoe Amulet`,
        longDesc: `The wearer of a dragonfoe amulet ignores the damage reduction of dragons. This only affects actual dragons, not all creatures of the dragon type. In addition, if the wearer casts a spell against a dragon, she can roll twice to overcome any spell resistance the dragon might possess, taking the higher result. Lastly, the wearer takes no damage instead of half damage on a successful Reflex save against a dragon's breath weapon (as the evasion ability).`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Periapt of Proof Against Poison`,
        longDesc: `The wearer is immune to poison, although poisons active when the periapt is first donned still run their course.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Amulet of Proof against Detection and Location`,
        longDesc: `This silver amulet protects the wearer from scrying and magical location just as a nondetection spell does. If a divination spell is attempted against the wearer, the caster of the divination must succeed on a caster level check (1d20 + caster level) against a DC of 19 (as if the wearer had cast nondetection on herself ).`,
        },
        {
        rarity: "legendary",
        type: ["neck"],
        name: `Scarab of Protection`,
        longDesc: `The scarab's possessor gains spell resistance 20. The scarab can also absorb energy-draining attacks, death effects, and negative energy effects. Upon absorbing 12 such attacks, the scarab turns to powder and is destroyed.`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Akoben Talisman`,
            longDesc: `Once per day when the wearer fails a saving throw against a spell or effect that causes him to fall asleep, he immediately receives a second saving throw. If he succeeds at the second saving throw, the horn sounds a loud warning that only the wearer can hear. The wearer becomes deafened and immune to sleep for 1 round as the sound echoes in his mind.`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Ankh Talisman`,
            longDesc: `Once per day when the wearer is hit by a creature with the energy drain ability, he receives a saving throw to negate the energy drain, using the DC listed for the ability (which usually determines whether temporary negative levels become permanent). If the creature's energy drain allows an initial saving throw, the talisman grants a second saving throw if the wearer fails his initial saving throw. If he succeeds at the saving throw granted by the talisman, the talisman releases a blast of force that automatically hits the attacker (as per force punch CL7)`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Hamsa Talisman`,
            longDesc: `Once per day when the wearer fails a saving throw against a hex, a spell or spell-like ability with the curse descriptor, or a hag's supernatural ability, he can attempt a second saving throw. If he succeeds at the second saving throw, the creature that targeted him must succeed at a saving throw using the same DC or suffer the effect. The talisman has no effect on spells and effects that don't allow a saving throw.`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Pentacle Talisman`,
            longDesc: `Once per day when an evil creature targets the wearer with magic jar, possessionOA, or a similar effect, or with a charm or compulsion spell or effect that allows the creature to exercise control over the wearer (such as suggestion, but not sleep). If the spell or effect allows a saving throw and the wearer fails it, he receives a second saving throw. If he succeeds at the second saving throw, the wearer is also protected by protection from evil for 5 rounds.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Scarab Talisman`,
            longDesc: `Once per day when the wearer fails a saving throw against a swarm's poison or distraction ability, he can attempt a second saving throw. If he succeeds at the second saving throw, the wearer becomes immune to the poison and distraction abilities of swarms for 5 rounds.`,
        },
        {
            rarity: "common",
            type: ["neck"],
            name: `Talisman of Arrow Protection`,
            longDesc: `The first time each day when the wearer is hit by two or more ranged attacks in a single round, he is immediately affected by protection from arrows CL3.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Danger Sense`,
            longDesc: `Once per day when the wearer rolls initiative they gain a +5 insight bonus to the roll.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Freedom`,
            longDesc: `The first time each day the wearer becomes grappled, entangled, or paralyzed, he is automatically affected by freedom of movement for 3 rounds (CL 7)`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Good Fortune`,
            longDesc: `The first time each day that the wearer rolls a natural 1 on a d20 roll (such as on an ability check, attack roll, saving throw, or skill check), he can immediately roll again and take the new result instead.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Healing Power`,
            longDesc: `The first time each day that the wearer is reduced to fewer than 1/2 his maximum hit points, he automatically heals 4d8+7 hit points.`,
        },
        {
            rarity: "epic",
            type: ["neck"],
            name: `Talisman of Healing Power`,
            longDesc: `The first time each day that the wearer dies, he is automatically affected by breath of life (CL9).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Protection from Flames`,
            longDesc: `The first time each day that the wearer takes 5 or more points of fire damage in a single round, he is automatically affected by protection from energy, which protects him from subsequent fire damage (CL5).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Protection from Frost`,
            longDesc: `The first time each day that the wearer takes 5 or more points of cold damage in a single round, he is automatically affected by protection from energy, which protects him from subsequent cold damage (CL5).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Protection from Electricity`,
            longDesc: `The first time each day that the wearer takes 5 or more points of electricity damage in a single round, he is automatically affected by protection from energy, which protects him from subsequent electricity damage (CL5).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Protection from Acid`,
            longDesc: `The first time each day that the wearer takes 5 or more points of acid damage in a single round, he is automatically affected by protection from energy, which protects him from subsequent acid damage (CL5).`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Talisman of Warrior's Courage`,
            longDesc: `The first time each day that the wearer would gain the frightened or panicked condition, he gains the shaken condition instead.`,
        },
        {
            rarity: "rare",
            type: ["neck"],
            name: `Triskelion Talisman`,
            longDesc: `Once per day when the wearer fails a saving throw against an effect that would cause him to become entangled, paralyzed, or slowed, he receives a second saving throw. If he succeeds at the second saving throw, the wearer instead gains the benefits of longstrider for 5 rounds.`,
        },
        
        {
            rarity: "epic",
            type: ["neck"],
            name: `Amulet of the Storm`,
            longDesc: `When worn, the amulet provides energy resistance 10 against cold and electricity. The wearer automatically identifies spells with the air, electricity, or water descriptor that are cast in their presence, as if they had succeeded at a Spellcraft check to do so. Once per day as an immediate action, the wearer of an amulet of the storm can attempt to counterspell any spell containing the air, electricity, or water descriptor as if the wearer were casting dispel magic. If this counterspell attempt is successful, it redirects the magical energy back at the caster in the form of bolts of lightning, dealing 1d6 points of electricity damage per level of the spell that was countered to the spell's original caster. A successful DC 18 Reflex save halves this damage.`,
        },
        {
        rarity: "legendary",
        type: ["neck"],
        name: `Necklace of Netted Stars`,
        longDesc: `This marvelous mithral necklace forms a broad, draping lacework of threadlike chains set with a multitude of tiny jewels. Seven of these jewels are larger than the rest. While wearing a necklace of netted stars, the wearer can create dancing lights at will and wandering star motes once per day. In addition, each of the seven jewels of the necklace can be used to reduce the cost of a spell by 2 spell points, even potentially reducing the cost of the spell to 0 spell points.
        
        Once per day, the wearer may use the necklace to catch a spell targeted at him, as if readying an action to counterspell using dispel magic, with a bonus on the check equal to 12 + the number of jewels not yet used to recall spells that day. If all jewels have been used, this ability cannot be used that day. The level of the spell to be countered must be less than or equal to the number of unused jewels. If the counterspell succeeds, the spell is negated and the wearer can use its magical energy to recall a previously cast spell of the same level or lower as an immediate action. Whether or not the attempt succeeds, this action exhausts the power of all of the necklace's jewels for that day.`,
        },
        {
        rarity: "common",
        type: ["hands"],
        name: `Assisting Gloves`,
        longDesc: `The wearer of these simple gloves can speak a command word create a glowing disembodied hand. As a swift action, the wearer can have the hand assist him with a task as if using the aid another action. The hand uses the wearer's base attack bonus or skill ranks when making the check to see if aid another is successful (it does not gain the benefit of the wearer's ability scores or other bonuses). The hand remains for 5 rounds.`,
        },
        {
        rarity: "common",
        type: ["hands"],
        name: `Challenger's Gloves`,
        longDesc: `By removing a glove and using it to make a melee or ranged touch attack against an opponent, the wearer of the other glove gains a +2 morale bonus on attack rolls against the target, and the target gains a —2 penalty on attack rolls against the wearer. Both of these effects last for 1 minute, but immediately end if anyone but the glove's wearer attacks the challenged opponent.`,
        },
        {
        rarity: "epic",
        type: ["hands"],
        name: `Gauntlets of the Skilled Maneuver`,
        longDesc: `The wearer of these gauntlets gains a +2 bonus to all CMB checks.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Gloves of Arrow Snaring`,
        longDesc: `Twice per day, the wearer can act as if he had the Snatch Arrows feat, even if he does not meet the prerequisites for the feat. Both gloves must be worn for the magic to be effective, and at least one hand must be free to take advantage of the magic.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Magnetist's Gloves`,
        longDesc: `Three times per day as a standard action, the wearer of these gloves may attempt a disarm combat maneuver on a target within 30 feet. The target's item must be mostly made of metal. If the combat maneuver check is successful, the target is disarmed and the item falls to the ground in the target's square. For every 5 by which the check exceeds the DC, the item lands 1 square closer to the wearer. If this would place the item in the wearer's square, the wearer may attempt to catch the item with a DC 10 Dexterity check; otherwise it lands in the wearer's square. The wearer can only use this ability if she has at least one hand free. If the wearer fails the combat maneuver check, she is not disarmed.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Deliquescent Gloves`,
        longDesc: `The wearer's melee touch attacks with that hand deal 1d6 points of acid damage. If the wearer uses that hand to wield a weapon or make an attack with an unarmed strike or natural weapon, that attack gains the corrosive weapon special ability.
        The wearer's gloved hand is protected from the acid ability of oozes, allowing him to use that hand to attack oozes with unarmed strike or natural attack without risk of harm from contact with the ooze. These unarmed strikes and natural attacks never cause an ooze to split.`,
        },
        {
            rarity: "rare",
            type: ["hands"],
            name: `Demonic Smith's Gloves`,
            longDesc: `Whenever the wearer makes a melee touch attack, she deals 1d6 points of fire damage. If the wearer wields a weapon or makes an attack with an unarmed strike, that attack gains the flaming weapon special ability. Additionally, you gain a +6 competence bonus on craft checks. If you roll a natural 1 on a craft check these gloves are destroyed.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Shadow Falconer's Gloves`,
        longDesc: `Once per day on command, its wearer can gesture toward a creature within 30 feet. When he does, a featureless silhouette of a bird of prey appears, swoops toward the target, and performs a disarm or steal combat maneuver (wearer's choice, CMB +16). The shadow falcon is a magical effect, not a creature, and this action does not provoke attacks of opportunity. If the hand wearing the glove is empty, the shadow falcon brings the item to the wearer's hand. If the gloved hand is occupied, the shadow falcon deposits the item on the ground in an unoccupied space adjacent to the wearer. The shadow falcon then disappears.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Spellstrike Gloves`,
        longDesc: `Three times per day as a swift action while making a melee attack the wearer of these gloves may cast and channel the effects of a touch spell through the attack as if using the spell strike ability. You must pay the cost of the spell as normal + 50%, however casting the spell does not provoke an attack of opportunity.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Pliant Gloves`,
        longDesc: `As a swift action, the wearer can lengthen his arms for up to 5 rounds per day, gaining an additional 5 feet of reach. These rounds need not be consecutive. Attacking with these extended arms is unwieldy, and the wearer takes a —2 penalty on attack rolls, increasing to —4 if he is using two-handed weapons. Even when his limbs aren't extended, the wearer gains a +5 enhancement bonus on Escape Artist checks and Acrobatics checks to avoid falling damage. The wearer is still able to use hand-based natural attack such as claws while wearing the gloves.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Gloves of Dueling`,
        longDesc: `These supple gloves grant the wearer a +4 bonus to her CMD against disarm attacks, attempts to sunder her wielded weapons, and effects that cause her to lose her grip on her weapons (such as grease). The wearer doesn't drop held weapons when panicked or stunned. Gain a bonus to your attack and damage with weapons of +2.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Vampiric Gloves`,
        longDesc: `Three times per day, when the wearer declares a melee attack they can activate these gloves to deal an additional 2d6 points of negative energy damage and gain temporary hit points equal to this bonus damage done. These temporary hit points last for 1 hour.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Giant Fist Gauntlets`,
        longDesc: `As a swift action, the wearer of these rough leather gauntlets can expand her hands to twice normal size and harden to the consistency of hardwood. This transformation lasts for up to 10 rounds per day, though they need not be consecutive rounds. If the wearer hits with an unarmed strike or natural attack using her enlarged hands, she may attempt to bull rush her opponent as a free action.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Gloves of the Shortened Path`,
        longDesc: `Once per day on command, the wearer of these oxblood leather gloves can bend space to extend her reach to a non-adjacent square within line of sight. For the next 10 rounds, she can touch anything in that square as if it were her own square, as long as she has line of effect to the target square. She may change the targeted square as a swift action.
        
        When using the gloves to touch, attack, or manipulate anything in the square, the wearer's arms and hands also appear in that square, allowing creatures and effects to target her as if she were in that square. She cannot use this connection to transfer anything from her square to the target square, or vice versa. If she drops anything, it lands in her square. She can use her hands (including natural attacks from those hands, if any), hand-held objects (such as lockpicks), and melee weapons in that square as if she were there. The square is part of her threatened area, though she cannot use the gloves to provide flanking for herself. She cannot use the gloves to grapple, make ranged attacks, or make attacks that require her to move out of her actual square (such as a bull rush combat maneuver).
        
        Interacting with the target square is distracting, and anything that threatens her in her actual square automatically flanks her.
        
        If the wearer or her square is blocked from using teleportation or planar travel effects (such as dimensional anchor), the gloves do not function. She cannot use the gloves to target a square protected by such an effect.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Talons of Leng`,
        longDesc: `Once donned, the talons of Leng grant the wearer a natural claw attack with each hand that deal 1d4 points of damage for a Medium wearer, or 1d3 points of damage for a Small wearer. These claw attacks have a +3 enhancement bonus on attack and damage rolls. On a critical hit, the target must succeed at a DC 20 Will save or become permanently confused as per the insanity spell. This is a mind-affecting effect.
        
        The wearer of the talons of Leng is immune to effects that grant the confused condition. For as long as she wears the talons, however, her Wisdom is reduced by 2, as alien voices constantly whisper through her head. The talons of Leng do not interfere with spellcasting, the use of handheld items, or wielding weapons.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Gauntlets of the Weaponmaster`,
        longDesc: `While wearing these gauntlets once per turn you can sheathe and draw a different weapon as a swift action (you must change weapons or this affect does not work), every time you swap weapons with a new weapon you gain a +3 to attack and damage on attacks with that new weapon for the rest of the round.`,
        },
        {
        rarity: "epic",
        type: ["hands"],
        name: `Poisoner's Gloves`,
        longDesc: `Each glove may be filled with a single dose of poison, a potion, alchemist infusion, holy water, or similar liquid as long as the liquid would not harm the gloves (for example, alchemist's fire and acid cannot be used). The wearer can deliver the dose to a target as a melee touch attack or as part of an unarmed strike or natural attack with the hands (such as a claw or slam attack). In the case of a personal infused extract, the opponent receives both a Fortitude save and spell resistance.
        
        The wearer can use both gloves in the same round using two-weapon fighting or multiple natural attacks (such as 2 slams or 2 claws). Each glove can be used once per day. Filling a glove is a full-round action that provokes attacks of opportunity.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Mask of Stony Demeanor`,
        longDesc: `This mask grants the wearer a +5 bonus for checks made to feint.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Cap of Light`,
        longDesc: `This small cloth skullcap resembles those some priests wear, but is topped with a small silver statue in the shape of a lit candle.
        
        The wearer can command the statue to radiate light (as light). The light can also be turned off on command.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Buffering Cap`,
        longDesc: `Once per day when struck by a critical hit, the wearer can spend an immediate action to convert the bonus damage of the critical hit into nonlethal damage. The cap has no effect if the wearer is immune to nonlethal damage.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Miser's Mask`,
        longDesc: `Gain a +4 bonus to skill rolls to obtain gold.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Stalker's Mask`,
        longDesc: `When worn, the mask desaturates the wearer's color, making him appear shadowy and granting a +5 competence bonus on Stealth checks. Once per day as a movement action, the wearer can become invisble as the invisiblity spell, but only to a single creature they can see. (CL5)`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Circlet of Persuasion`,
        longDesc: `This delicately engraved silver headband grants its wearer a +3 competence bonus on Charisma-based checks.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Grappler's Mask`,
        longDesc: `The wearer may attempt to bull rush and grapple without provoking attacks of opportunity.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Helm of Fearsome Mien`,
        longDesc: `This metal helm is made to look like the wearer has large fangs and other features resembling a fearsome predator. Three times per day you can roll an intimidation check to demoralize an opponent you can see as a movement action.`,
        },
        {
        rarity: "common",
        type: ["head"],
        name: `Jingasa of the Fortunate Soldier`,
        longDesc: `This conical iron jingasa, or war hat, grants the wearer a +1 deflection bonus to AC. When struck by a critical hit or sneak attack, the wearer can spend an immediate action to negate the critical hit or sneak attack (similar to the fortification armor special ability, but without requiring a roll). The damage is instead rolled normally.
        
        This ability functions only once, though the jingasa continues to grant its deflection bonus even after the other ability is expended.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Crown of Swords`,
        longDesc: `This radiant crown of steel is bedecked with miniature mithral swords. A crown of swords can be used up to 10 times per day. When struck in combat, the wearer may spend one use as an immediate action to create a longsword-shaped spiritual weapon that then attacks her attacker. On the wearer's next turn, she may spend one additional use each round to continue attacking that target with the spiritual weapon; the spiritual weapon cannot be redirected and disappears if the target is killed or moves out of range. Multiple spiritual weapons may be created (even attacking the same target) if the wearer is attacked in subsequent rounds.`,
        },
        {
        rarity: "rare",
        type: ["head"],
        name: `Crown of Blasting`,
        longDesc: `On command (standard), this simple golden crown projects a blast of searing light (3d8 points of damage) once per day. (CL6)`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Greater Crown of Blasting`,
        longDesc: `On command (standard), this elaborate golden crown projects a blast of searing light (5d8 maximized for 40 points of damage) once per day. (CL17)`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Mask of the Krenshar`,
        longDesc: `Three times per day the wearer can command the mask to appear to retract the wearer's skin, revealing an illusion of the wearer's glistening skull and musculature. Creatures within 100 feet who see this display must succeed at a (DC intimidate modifier) Will save or become frightened (if the target has 6 or fewer Hit Dice) or shaken (if the target has more than 6 HD) for 1d4 rounds. This is a mind-affecting fear effect and a glamer. Anyone who can see through illusions (such as by true seeing) is unaffected.`,
        },
        {
        rarity: "rare",
        type: ["head"],
        name: `Plague Mask`,
        longDesc: `This stylized bird mask consists of a pair of goggles attached to a ceramic beak that covers the nose and mouth.
        
        The goggles are not magic and can be replaced with other goggles or eye slot items. It grants the wearer a +4 resistance bonus on saving throws against disease. Once per day on command, the user can remove disease (as the spell) on a single creature touched.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Helm of the Mammoth Lord`,
        longDesc: `This hide helm is set with plates of ivory carved with primitive runes, with a pair of tusks curving down on either side of the wearer's face for cheek guards. The tusks of the helm provide a gore attack dealing 1d6 points of damage for a Medium wearers (or 1d4 points of damage for Small wearers) and counts as a magic weapon for the purposes of overcoming damage reduction.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Veil of Fleeting Glances`,
        longDesc: `In addition to hiding the face, this fine lace veil protects the wearer against gaze attacks. The wearer has a 50% chance to avoid making a saving throw against a gaze attack even when not averting her eyes. If the wearer averts her eyes, she rolls twice (once for the veil, once for averting her eyes) and uses the more favorable result.
        
        Against patterns, visual figments, and other vision-based effects and attacks that cannot affect blind creatures, the veil grants the wearer a +4 circumstance bonus on saving throws. The veil does not otherwise impede the wearer's vision in any way.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Mask of a Thousand Tomes`,
        longDesc: `The mask grants its wearer a +10 competence bonus on all Knowledge skill checks, but all ranged attacks made by the wearer have a 20% miss chance, this must be rolled sperately if there the target has another miss chance.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Medusa Mask`,
        longDesc: `The mask grants a +4 bonus on all saving throws against visual effects, including gaze attacks and sight-based illusions. Once per day as a standard action, the wearer can cause the central gemstone to glow with pale green light, at which point she may target any one creature within 30 feet. The targeted creature must succeed at a DC 15 Fortitude save or be petrified for 1 minute, as if by flesh to stone.`,
        },
        {
        rarity: "rare",
        type: ["head"],
        name: `Cap of the Free Thinker`,
        longDesc: `Once per day, when the wearer fails a saving throw against a mind-affecting effect, she can reroll the save and take the second result.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Halo of Inner Calm`,
        longDesc: `This Halo grants the wearer a +4 resistance bonus on saving throws against all spells with the emotion descriptor. When worn by a character of a good alignment, it provides spell resistance 13 against spells with the evil descriptor and a +2 sacred bonus on saving throws.`,
        },
        {
        rarity: "rare",
        type: ["head"],
        name: `Cat's Eye Crown`,
        longDesc: `The wearer gains darkvision 60 feet, or increases her darkvision by 60 feet if she already possesses that sense.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Maw of the Wyrm`,
        longDesc: `The helm's wearer gains a +4 competence bonus on Intimidate checks and a +4 insight bonus on saves to resist a dragon's frightful presence aura.
        
        Once per day on command, the wearer can breathe out a blast of energy, as the dragon's breath spell to mimic the breath weapon of a dragon (CL7) (7d6 points of damage, Reflex DC 16 half). The element of this breath weapon is random when activated (fire, cold, electricity, acid)`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Magician's Hat`,
        longDesc: `Three times per day as a free action when casting a spell you can apply the effects of a metamagic feat without increasing the spell point cost of casting the spell. You must still have a spell of a high enough slot to cast the spell with the metamagic feat, however you can reduce the level adjustment of the metamagic feat by 1.`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Circlet of Mindsight`,
        longDesc: `When worn, the circlet lets the wearer sense the presence of other thinking creatures in her immediate area. The wearer gains the benefits of blindsense 30 feet, but only against creatures with an Intelligence score that are susceptible to mind-affecting effects.
        
        Undead, constructs, and mindless creatures like most oozes and vermin cannot be perceived when using the circlet, nor can creatures under the effects of mind blank or a ring of mind shielding.`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Mask of the Skull`,
        longDesc: `Once per day, the mask can be loosed to fly from the wearer's face. It travels up to 50 feet away from the wearer and attacks a target assigned to it. The grinning skull mask makes a touch attack against the target based on the wearer's base attack bonus. If the attack succeeds, the target must make a DC 20 Fortitude save or take 130 points of damage, as if affected by a finger of death spell. If the target succeeds on his saving throw, he nevertheless takes 3d6+13 points of damage. After attacking (whether successful or not), the mask flies back to its user. The mask has AC 16, 10 hit points, and hardness 6. (CL13)`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Howling Helm`,
        longDesc: `On command three times per day, the wearer can unleash a terrifying howl. When he does so, he makes a single Intimidate check to demoralize all opponents within 30 feet that can hear the howl. At the start of the wearer's following turn, 1d3 wolves appear as if summoned by the spell summon nature's ally III. They act on the wearer's initiative and follow her instructions (or attacking her opponents, if she cannot communicate with them) for 5 rounds before vanishing in a swirl of pine needles and snow.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Helm of Underwater Action`,
        longDesc: `The wearer of this helmet can see underwater. Drawing the small lenses in compartments on either side into position before the wearer's eyes activates the visual properties of the helm, allowing her to see five times farther than water and light conditions would allow for normal human vision. (Weeds, obstructions, and the like block vision in the usual manner.) If the command word is spoken, the helm of underwater action gives the wearer a 30-foot swim speed and creates a globe of air around the wearer's head and maintains it until the command word is spoken again, enabling her to breathe freely.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Crown of Conquest`,
        longDesc: `The wearer gains a +4 competence bonus on Intimidate checks, and whenever he confirms a critical hit, the crown creates a prayer effect centered on the crown's wearer (caster level 5th).`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Batrachian Helm`,
        longDesc: `Three times per day as a swift action, the helm fires an unerring tongue of force at a visible target within 20 feet.
        
        If the target is an unattended object weighing 250 pounds or less, it is pulled 20 feet toward the wearer. If the target is a creature of the wearer's size or smaller, the wearer may make a combat maneuver check as a free action to pull the target 20 feet toward him.
        
        If the target is a creature larger than the wearer, an unattended object weighing more than 250 pounds, or an immobile structure such as a wall, the wearer is pulled 20 feet toward the target. This movement does not provoke attacks of opportunity, and the object or creature stops if the movement would move it into a solid object or creature.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Laurel of Command`,
        longDesc: `As a swift action, the wearer can speak words of encouragement or advice to an ally within 30 feet. That ally gains a +2 morale bonus on attack rolls, saving throws, skill checks, and ability checks until the start of the wearer's next turn. The wearer can use the laurel to grant this bonus to himself. A creature cannot gain this bonus more than once per day.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Mask of Giants`,
        longDesc: `As a standard action the wearer of the mask grows in size as if affected by the enlarge person, except that the modifier to its strength score becomes a +4 instead of +2. This lasts 5 rounds.`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Greater Mask of Giants`,
        longDesc: `As a standard action the wearer of the mask grows in size as if affected by the enlarge person except that it grows 2 sizes instead of one. Its strength increase by +8, its dexterity is reduced by -4, it gains a -2 to attack and AC, and gains a +2 to CMB and CMD. This lasts 5 rounds.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Steel-Mind Cap`,
        longDesc: `The helmet takes control of the wearer's body anytime he is dazed or stunned. Whenever the wearer would be dazed, he is instead confused. Whenever the wearer would be stunned, he is instead confused and staggered.
        
        Time spent under the cap's influence counts against the duration of the daze or stun effect. The cap functions for up to 5 rounds per day. These rounds do not need to be consecutive.`,
        },
        {
        rarity: "epic",
        type: ["head"],
        name: `Stormlord's Helm`,
        longDesc: `Three times per day the wearer of this helm can use a standard action to cause the helm to cast lightning bolt at caster level 10.`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Helm of Teleportation`,
        longDesc: `A character wearing this helm may teleport three times per day, instantly transporting himself and objects he might be carrying on his person to a designated destination, exactly as if he had cast the spell of the same name. Activating this is a movement action that does not provoke and only requires a mental action.`,
        },
        {
        rarity: "legendary",
        type: ["head"],
        name: `Halo of Menace`,
        longDesc: `When placed over the head, this halo of shimmering polished steel floats above it, though it still takes up the head slot. The halo constantly radiates a 20-foot-radius aura from its wearer. Any hostile creature within the aura must succeed at a DC 20 Will save or take a -2 penalty on attack rolls, saving throws, and AC for the next 24 hours or until it hits the wearer with an attack or damages it with a spell, spell-like ability, or supernatural ability. Chaotic creatures take a -2 penalty on this saving throw. A creature that has resisted or broken the effect of the halo of menace cannot be affected by the same wearer's aura for 24 hours. The aura is a mind-affecting effect. The will save DC increases by 1 for every 5 of the modifier of your intimidate skill.`,
        },
        {
        rarity: "unique",
        type: ["head"],
        name: `Crown of Heaven`,
        longDesc: `If worn by a lawful good or neutral good creature this helm grants a +2 sacred bonus to armor class and saves, increasing by an additional +2 against evil creatures.  In addition, as a full-round action, the wearer can create an aura of sanctity for as long as she concentrates. This aura provides a +4 deflection bonus to AC and a +4 resistance bonus on saving throws against attacks made or effects created by evil creatures, as well as the benefits of a magic circle against evil and a lesser globe of invulnerability, and at the end of your turn heal all allies within 20 feet for 2d8+10, increasing to 5d8+20 if they are also a good creature. If they are an evil creature they only gain 1d8+5 healing. This helm can only be worn by a lawful good or neutral good creature or the wearer gains a permanent negative level each round it continues to wear it.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Medallion of Glory`,
        longDesc: `When using an ability that uses positive energy to heal or damage undead the bearer can treat one die roll of a 1 as a maximum roll when determining the amount of damage healed by living creatures or dealt to undead creatures. In addition, once per day, the bearer can expend spell points to dispel a darkness spell of lower than 9th level within a 30-foot-radius burst. 3 spell points are consumed for each level of the darkness spells dispelled. If not enough spell points are used the darkness is not dispelled.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Mantle of the Faithful Vessel`,
        longDesc: `When the wearer channels energy, uses lay on hands, a healing hex, or soothing performance, any creatures healed by the energy gain the benefits of bless for 1 minute, and any creatures harmed by the energy are subjected to bane (Will DC 11 negates) for 2 rounds. Add your level to the healing or damage of all of these abilities. `,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Protected Life`,
        longDesc: `If the wearer has the channel energy or a hex that heals, the radius/range of the ability increases by 5 feet. Additionally, when the wearer uses it, he may choose to exempt one creature from the effects of his healing. If the wearer has the Selective Channeling feat, the ring of protected life increases the number of creatures he may normally exempt by one. Finally, once per day the wearer may reduce the action step of that that healing ability by two. This does not provoke attacks of opportunity; doing so renders the ring of protected life inert for 24 hours, during which time it does not confer any benefits.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Force Shield`,
        longDesc: `This ring generates a shield-sized (and shield-shaped) wall of force that stays with the ring and can be wielded by the wearer as if it were a heavy shield (+2 AC). This special creation has no armor check penalty or arcane spell failure chance since it is weightless and encumbrance-free. It can be activated and deactivated at will as a free action.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of the Ram`,
        longDesc: `The ring of the ram is an ornate ring forged of hard metal, usually iron or an iron alloy. It has the head of a ram as its device. The ring of the ram has 10 charges per day. The wearer can command the ring to give forth a ram-like force, manifested by a vaguely discernible shape that resembles the head of a ram or a goat. This force strikes a single target, dealing 1d6 points of damage if 1 charge is expended, 2d6 points if 2 charges are used, or 3d6 points if 3 charges (the maximum) are used. Treat this as a ranged attack with a 50-foot maximum range and no penalties for distance.
        
        The force of the blow is considerable, and those struck by the ring are subject to a bull rush if within 30 feet of the ring-wearer. The ram is Large and uses the ring's caster level as its base attack bonus with a Strength of 25. This gives the ram a Combat Maneuver Bonus of +17. The ram gains a +1 bonus on the bull rush attempt if 2 charges are expended, or +2 if 3 charges are expended.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Curing`,
        longDesc: `Whenever the wearer of a ring of curing casts a conjuration spell of the healing subschool, all maximums to the level-dependent healing provided by that spell increase by 5. For example, cure light wounds would provide a maximum healing of 1d8 + 10 (at 10th caster level), while heal would cure a maximum of 200 points of damage. This ring does not increase the wearer's actual caster level, nor the amount of level-dependent healing provided by any such spell.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Foe Focus`,
        longDesc: `The wearer of the ring can, at will as a standard action, designate any one opponent she can see as a particularly dangerous foe. She gains a +2 bonus to her AC and saving throws against attacks made by that opponent until she designates a new enemy.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Transposition`,
        longDesc: `Once per day, the wearer of the ring of transposition can speak a command word as a standard action to exchange places with a friendly creature, which must be within 800 feet, as though using a dimension door spell against a willing target.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Tactical Precision`,
        longDesc: `Anytime the wearer gives or receives a numeric bonus from a teamwork feat or the aid another action, that bonus increases by +1.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Decoy`,
        longDesc: `Whenever the wearer of this ring takes the withdraw action or becomes helpless (including falling unconscious), it instantly makes her invisible for 3 rounds and creates four illusory duplicates that either run off in opposite directions or perform other plausible actions that could draw enemy attention away from her. The duplicates last for 3 rounds before disappearing, but they instantly pop out of existence if struck by an attack (AC 10) and can be disbelieved (Will DC 19). Allies of the wearer always know her true location and can freely provide aid or assistance to her.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Ectoplasmic Invigoration`,
        longDesc: `The wearer of this ring can absorb a creature they summoned as a standard action to gain 2 temporary hit points per hit dice of the creatures absorbed.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Minor Ring of Fire Resistance`,
        longDesc: `The wearer of this ring gains 5 fire resistance`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Minor Ring of Acid Resistance`,
        longDesc: `The wearer of this ring gains 5 acid resistance`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Minor Ring of Cold Resistance`,
        longDesc: `The wearer of this ring gains 5 cold resistance`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Minor Ring of Electricity Resistance`,
        longDesc: `The wearer of this ring gains 5 electricity resistance`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Fire Resistance`,
        longDesc: `The wearer of this ring gains 10 fire resistance`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Acid Resistance`,
        longDesc: `The wearer of this ring gains 10 acid resistance`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Cold Resistance`,
        longDesc: `The wearer of this ring gains 10 cold resistance`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Electricity Resistance`,
        longDesc: `The wearer of this ring gains 10 electricity resistance`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Greater Ring of Fire Resistance`,
        longDesc: `The wearer of this ring gains 20 fire resistance`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Greater Ring of Acid Resistance`,
        longDesc: `The wearer of this ring gains 20 acid resistance`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Greater Ring of Cold Resistance`,
        longDesc: `The wearer of this ring gains 20 cold resistance`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Greater Ring of Electricity Resistance`,
        longDesc: `The wearer of this ring gains 20 electricity resistance`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Legendary Ring of Fire Resistance`,
        longDesc: `The wearer of this ring gains 50 fire resistance`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Legendary Ring of Acid Resistance`,
        longDesc: `The wearer of this ring gains 50 acid resistance`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Legendary Ring of Cold Resistance`,
        longDesc: `The wearer of this ring gains 50 cold resistance`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Legendary Ring of Electricity Resistance`,
        longDesc: `The wearer of this ring gains 50 electricity resistance`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Minor Ring of Energy Resistance`,
        longDesc: `The wearer of this ring gains 5 fire, electricity, acid, and cold resistance`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Energy Resistance`,
        longDesc: `The wearer of this ring gains 10 fire, electricity, acid, and cold resistance`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Greater Ring of Energy Resistance`,
        longDesc: `The wearer of this ring gains 20 fire, electricity, acid, and cold resistance`,
        },
        {
        rarity: "unique",
        type: ["shoulders"],
        name: `Cloak of Endure Elements`,
        longDesc: `Gain immunity to fire and cold damage.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of the Troglodyte`,
        longDesc: `Two times per day on command, the wearer of this ring can produce a horrific smell affecting all living creatures other than the wearer within a 10-foot radius. Once created, the smell remains, centered on the wearer, until she dismisses it as a free action. This is a poison effect.
        
        Any creature affected by the disgusting aroma produced by the ring must succeed at a DC 14 Fortitude saving throw when it starts its turn in the ring's stench radius. Those that fail a saving throw become sickened for 1 round. If they are already sickened, they become nauseated for 1 round instead.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Steelhand Circle`,
        longDesc: `The wearer ignores the first 5 points of an object's hardness when performing a sunder combat maneuver or when smashing an object. She also does not take the standard —4 penalty for making a combat maneuver check to disarm while unarmed.
        
        Additionally, the ring's wearer can focus all of the ring's power, possibly repelling a devastating blow. Once per day, when a critical hit or sneak attack is scored on the wearer, there is a 50% chance that the critical hit or sneak attack is negated and damage is instead rolled normally. Using this ability is an immediate action, and the wearer must decide to use it before the critical hit or sneak attack damage is rolled.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Chameleon Power`,
        longDesc: `As a free action, the wearer of this ring can gain the ability to magically blend in with the surroundings. This provides a +10 competence bonus on her Stealth checks. As a standard action, she can also use the spell disguise self as often as she wants.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of the Sea Strider`,
        longDesc: `The ring grants its wearer a swim speed of 30 feet, as well as +8 racial bonus on Swim checks for having a swim speed. Furthermore, once per day as a swift action, as long as the wearer is in contact with liquid, he can use dimension door as the spell, but its starting and ending points must be connected by a contiguous mass of liquid.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Retribution`,
        longDesc: `Once per day, the wearer of this charred bone ring may, as an immediate action, cause it to detonate in a 30-foot-radius burst that deals 10d6 points of fire damage (Reflex DC 14 half). The wearer is also subject to this damage.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Water Walking`,
        longDesc: `This ring is often made of coral or bluish metal decorated with motifs depicting rolling waves of water. The ring allows the wearer to continually utilize the effects of the spell water walk.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Minor Ring of Inner Fortitude`,
        longDesc: `A minor ring of inner fortitude reduces ability damage or temporary ability penalties the wearer takes by 2 points and ability drain by 1 point. If an effect targets multiple ability scores (for example, exhaustion, fatigue, or touch of idiocy), the ring reduces the damage, drain, or penalty for all ability scores. Wearing a ring of inner fortitude does not make the wearer immune to conditions such as fatigued or exhausted even if the wearer ignores all ability damage, drain, or penalties from the condition.
        
        If the ring prevents any damage, drain, or penalties that are associated with a beneficial effect, it also negates the beneficial effect.`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Major Ring of Inner Fortitude`,
        longDesc: `A major ring of inner fortitude reduces ability damage or temporary ability penalties the wearer takes by 4 points and ability drain by 2 points. If an effect targets multiple ability scores (for example, exhaustion, fatigue, or touch of idiocy), the ring reduces the damage, drain, or penalty for all ability scores.  Wearing a ring of inner fortitude does not make the wearer immune to conditions such as fatigued or exhausted even if the wearer ignores all ability damage, drain, or penalties from the condition.
        
        If the ring prevents any damage, drain, or penalties that are associated with a beneficial effect, it also negates the beneficial effect.`,
        },
        {
        rarity: "unique",
        type: ["ring"],
        name: `Greater Ring of Inner Fortitude`,
        longDesc: `A major ring of inner fortitude reduces ability damage or temporary ability penalties the wearer takes by 6 points and ability drain by 3 points. If an effect targets multiple ability scores (for example, exhaustion, fatigue, or touch of idiocy), the ring reduces the damage, drain, or penalty for all ability scores. Wearing a ring of inner fortitude does not make the wearer immune to conditions such as fatigued or exhausted even if the wearer ignores all ability damage, drain, or penalties from the condition.
        
        If the ring prevents any damage, drain, or penalties that are associated with a beneficial effect, it also negates the beneficial effect.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Invisibility`,
        longDesc: `By activating this simple silver ring (standard action), the wearer can benefit from invisibility, as the spell. (CL3)`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Evasion`,
        longDesc: `This ring continually grants the wearer the ability to avoid damage as if she had evasion. Whenever she makes a Reflex saving throw to determine whether she takes half damage, a successful save results in no damage.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Blink`,
        longDesc: `On command (standard action), this ring makes the wearer blink, as the blink spell (CL7).`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Return`,
        longDesc: `Three times per day, the wearer of the ring can, as a move action, use it to form a link with the particular 5-foot square she occupies at that moment. This causes one of the stones on the ring to glow. As a swift action, the wearer of the ring can teleport to any unoccupied linked square within 100 feet.`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Freedom of Movement`,
        longDesc: `This gold ring allows the wearer to act as if continually under the effect of a freedom of movement spell.`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Delayed Doom`,
        longDesc: `Whenever the mind or body of this ring's wearer first becomes subject to any harmful effect that allows a saving throw to resist or mitigate it, he may, as an immediate action, choose to delay the onset of that effect for 1 round, after he fails the saving throw but before its effects occur. This activation causes one of the ring's nine garnets to turn to powder. When that round passes, the wearer may continue to delay the onset of this harmful effect an additional minute as an immediate action by willing the ring to do so, which destroys another garnet, thus repeating the cycle for another round. The delayed harmful effect occurs when the wearer falls unconscious, when the ring is removed, or 1 round after the last time the ring's power activated; rounds spent delaying the effect do not count toward the effect's duration (for example, a curse that lasts 5 rounds takes effect for a full 5 rounds, even if the wearer delayed its effect several rounds). Effects that protect against or negate the harmful effect work normally while it is delayed. Once all 9 gems are used the ring becomes useless`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Friend Shield`,
        longDesc: `This ring can be used to cast shield other (standard) at will on any party member regardless of distance. (CL10)`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Continuation `,
        longDesc: `Whenever the wearer of the ring casts a spell with a range of personal the duration is doubled.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Spiritualist Rings`,
        longDesc: `The wearer's weapons gain the ghost touch weapon special ability while the wearer is wielding the weapons. The wearer gains a +4 sacred or profane bonus on saving throws against positive and negative energy effects. The bonus depends on the wearer's alignment—good-aligned wearers gain a sacred bonus, whereas evil-aligned wearers gain a profane bonus. Neutral-aligned wearers pick either a sacred or profane bonus when the ring is first put on, which cannot be changed later.`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Telekinisis`,
        longDesc: `This ring, knotted with metallic tendrils encasing a setting of red and amber gemstones, allows the caster to use the spell telekinesis on command (standard), lifting and manipulating objects at a distance using only her mind. (CL9)`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Regeneration`,
        longDesc: `This white gold ring is generally set with a large green sapphire. When worn, the ring continually allows a living wearer to heal 3 points of damage per round and an equal amount of nonlethal damage. In addition, the wearer is immune to bleed damage while wearing a ring of regeneration. If the wearer loses a limb, an organ, or any other body part while wearing this ring, the ring regenerates it as the spell regenerate. In either case, only damage taken while wearing the ring is regenerated.`,
        },
        {
        rarity: "unique",
        type: ["ring"],
        name: `Ring of Spell Turning`,
        longDesc: `Up to two times per day on command, this simple platinum band automatically reflects the next nine levels of spells cast at the wearer, exactly as if spell turning had been cast upon him. (CL13)`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Fast Healing`,
        longDesc: `Gain fast healing 1 while wearing this ring.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Forcefangs`,
        longDesc: `This band negates any force spell or force spell-like ability targeted at the wearer. Doing so gives the ring a number of charges equal to the spell level of the incoming force effect. The ring can hold a maximum of 9 charges.
        
        If an incoming force attack would charge the ring beyond this limit, the ring does not negate the attack or gain charges, and the attack affects the wearer normally. On command, the wearer can use the ring's charges to cast magic missile, unleashing one missile (1d4+1 force damage) per charge but no more than five missiles per round.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Strength Sapping`,
        longDesc: `This ring is made of black steel and is eerily cold to the touch. Once per day as a swift action, when the wearer hits a living creature with an unarmed attack, the target must succeed at a DC 20 Fortitude saving throw or take 1d4 point of Strength damage in addition to the attack's normal damage. If the target of the attack takes any Strength damage from this attack, the ring's wearer gains a +2 enhancement bonus to her Strength for 1 minute.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Feather Falling`,
        longDesc: `This ring is crafted with a feather pattern all around its edge. It acts exactly like a feather fall spell, activated immediately if the wearer falls more than 5 feet.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Sustenance`,
        longDesc: `When worn this ring heals creatures for level hit points and level/2 spell points each time it descends a floor, or when it is healed using a heal check.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Ferocious Action`,
        longDesc: `Once per day, when the wearer gains the staggered condition from an enemy's attack or ability, she can ignore that condition for up to 3 rounds. This does not prevent her from gaining the staggered condition again, and it doesn't protect her if she gained the staggered condition multiple times.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Rat Fangs`,
        longDesc: `This bone ring is the shape of an elongated rat biting its own tail. The wearer gains a bite attack as a primary natural attack. This attack deals 1d4 points of piercing damage for a Medium wearer or 1d3 points of damage for a Small wearer.`,
        },
        {
        rarity: "common",
        type: ["ring"],
        name: `Ring of Swarming Stabs`,
        longDesc: `As a swift action you can add 1d6 of sneak attack damage to your next attack this turn. This attack must qualify for it still, such as when flanking a creature or attacking it while it is flat footed. You can instead cause it to make all of your attacks for the rest of the round add this additional sneak attack damage, but if you do the ring is unusable for the rest of the floor.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Mnemonic Amplification`,
        longDesc: `Whenever an ability or potion would cause you to restore spell points you gain an additional 2 spell points. Up to 10 spell points can be stored inside of this ring and used freely.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Mnemonic Regeneration`,
        longDesc: `Each turn at the start of your turn you regenerate 1 spell point.`,
        },
        {
        rarity: "legendary",
        type: ["ring"],
        name: `Ring of Greater Mnemonic Regeneration`,
        longDesc: `Each turn at the start of your turn you regenerate 3 spell points.`,
        },
        {
        rarity: "unique",
        type: ["ring"],
        name: `Ring of Legendary Mnemonic Regeneration `,
        longDesc: `Each turn at the start of your turn you regenerate 5 spell points.`,
        },
        {
        rarity: "rare",
        type: ["ring"],
        name: `Ring of Soul Tethering`,
        longDesc: `The time limit for restoring the wearer to life via spells such as breath of life or raise dead is suspended. This ring has no effect if it is placed upon a corpse; it must be worn at the time the creature dies to tether its soul.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Counterspells`,
        longDesc: `Once per day the wearer of this ring may as an immediate action counterspell a spell that is about to affect them at caster level 10. They do not need to roll a spellcraft to decipher the spell, and this can even be used on spell-like abilities, but if so it only protects the wearer from the spell if the dispel check is successful.`,
        },
        {
        rarity: "epic",
        type: ["ring"],
        name: `Ring of Arcane Mastery`,
        longDesc: `This ring can store up to 6 spell points inside of it and be used freely. It also allows you to spend the spell points inside of the ring for various effects:
        as a free action spend 2 spell points to gain a +2 to concentration checks for the rest of the round
        as a movement action for the spells level while casting a spell you can increase the damage of the spell by 1 point per dice of the spells damage.
        as a standard action you can spend 2 spell points to fire a ray as a ranged touch attack with a range of 60 feet that deals 2d6 of force damage. You can increase the spell point cost of this by 2 spell points to increase the damage by 1d6.
        For all of these abilities you can never spend more than 6 spell points in a round.`,
        },
        {
        rarity: "unique",
        type: ["head"],
        name: `Crown of the Pack Leader`,
        longDesc: `While wearing this crown the wearer enhances the power of their teamwork feats and the teamwork feats of those working in conjuction with them. While gaining a numerical bonus from a teamwork feat you increase the bonus by +1, the teammates that you are working with to utilize that teamwork feat also gain a +1 numerical bonus to their teamwork feats. While using the animal focus perk to gain an animal aspect you can reduce the spell point cost per round by 1 spell point.`,
        },
        {
        rarity: "unique",
        type: ["chest"],
        name: `Stat Sticker`,
        longDesc: `Any perk that gives a bonus to attack or damage has its bonus increased by +1.`,
        },
        {
        rarity: "unique",
        type: ["wrist"],
        name: `Bracers of Whirling Steel`,
        longDesc: `Whenever you are making a full round attack while two weapon fighting you can make an additional attack at your highest attack bonus -10 with both weapons.`,
        },
        {
        rarity: "unique",
        type: ["hands"],
        name: `Gravity Gloves`,
        longDesc: `For each dice size increase your weapons or unarmed attacks currently have, those attacks gain +1 to damage. (This is Akashic Paths dice steps, so wilding strikes gives +1 to damage, and enlarge person gives +2 damage)`,
        },
        {
        rarity: "unique",
        type: ["eyes"],
        name: `Divine Hunter's Monacle`,
        longDesc: `When you gain a sacred bonus increase it by +2. Gain a +5 on checks to identify creatures, and if you successfully identify a creature (dc=20+HD) you gain a +2 to attack and damage against them. Increase these bonuses to +4 if you beat the dc by 8.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of Unlimited Focus`,
        longDesc: `Any perk that requires spell points per round to keep active have their spell point cost reduced by 1. Once per day you can activate the perk as a swift action, if it was already a swift action reduce it to a free action. The perk only lasts 3 rounds or its normal duration whichever is less when activated this way.`,
        },
        {
        rarity: "unique",
        type: ["head"],
        name: `Headband of Ultimate Techniques`,
        longDesc: `The DC of all of your maneuvers increases by 3, Whenever you initiate a martial strike gain +2 to attack and they deal an additional 1d6 damage. Once per day you can initiate two strikes with initiation actions of a standard action or less on a single attack as a standard action, applying the affects of both strikes to that single attack. Only one strike can include multiple attacks, and if it does it only applies the effects of the second strike to the first attack.`,
        },
        {
        rarity: "unique",
        type: ["shoulders"],
        name: `Cloak of Ultimate Style`,
        longDesc: `Each round you gain 3 additional attacks of opportunity. This stacks with any additional sources of attacks of opportunity. Whenever you make an attack of opportunity or a counter maneuver you gain a bonus to d20 rolls equal to half your ranks in perform (minimum 1)`,
        },
        {
        rarity: "unique",
        type: ["shoulders"],
        name: `Ares' Red Cloak`,
        longDesc: `Whenever you gain a morale bonus to a physical ability score you can choose to increase the bonus they give by +3 but receive a -2 to AC for the duration of the entire effect. If an effect gives multiple morale bonuses you can apply this to all of them for accumulating -2 AC for each additional ability score boosted.`,
        },
        {
        rarity: "unique",
        type: ["feet"],
        name: `Windrunner's Shoes`,
        longDesc: `You can make a full attack with a ranged weapon as a standard action, however you lose your attack at your full base attack bonus (if you have the manyshot feat, the manyshot becomes your first attack in the round at the lower bonus). You can also choose to still make your full-round attack as a full-round action, if you do, you can make an additional attack at your highest attack bonus, but all attacks you make that round receive a -2 penalty.`,
        },
        {
        rarity: "unique",
        type: ["head"],
        name: `Crown of the Shining Crusader`,
        longDesc: `This crown can only be worn by good creatures. Whenever you make a successful attack against an evil creature you and all adjacent allies heal 1d6 hit points. Whenever you activate your smite evil or judgement ability your attacks with weapons gain the holy property, and your highest mental stat counts as 8 higher for determining your bonuses.`,
        },
        {
        rarity: "unique",
        type: ["hands"],
        name: `The Black Hands`,
        longDesc: `Each round the first attack you make applies any sneak attack you may have. If the creature is immune or resistant to sneak attacks this still applies but treat its resistance as if it was 25% lower (creatures immune have a 75% chance of ignoring sneak attack)`,
        },
        {
        rarity: "unique",
        type: ["chest"],
        name: `Bomb Vest`,
        longDesc: `Gain a +5 bonus to craft. Additionally, if using alchemy to create a bomb, increase your effective level for creating them by 2, they now have a splash radius of 10 feet.`,
        },
        {
        rarity: "unique",
        type: ["head"],
        name: `Funny Mask`,
        longDesc: `If you have the bardic performance perk: Increase the bonus inspire courage gives by +1, you do not need to spend additional spell points to gain this bonus. You can use your timed advice an additional time per round as a free action that can be taken even when its not your turn for 5 spell points.`,
        },
        {
        rarity: "unique",
        type: ["chest"],
        name: `Beacon of Light`,
        longDesc: `When using channel energy you can choose to not affect up to 3 creatures from the effect of the channel. If you do your channel gains a bonus to its or damage healing of +3 for each creatures ignored. When using channel energy you can increase the radius of your channel energy by 5 feet by spending an additional spell point, which can be done multiple times.`,
        },
        {
        rarity: "unique",
        type: ["chest"],
        name: `Vest of the Warpriest`,
        longDesc: `For each spell of the buff type currently affecting you, you gain +1 deflection bonus to armor class, a +1 resistance bonus to your saving throws, and a +1 bonus to damage rolls with weapons. You can choose to change the type of any of these bonuses to untyped however its bonus is reduced by half, minumum 0. Once per day when using the fervor perk to cast a buff on yourself you can also affect all allies within 30 feet.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Bloodlords Robes`,
        longDesc: `Gain a +4 Inherent bonus to your constitution. Whenver you use the hemomancy or blood tap perk to gain spell points you gain 1 additional spell point per dice rolled. Whenever you use hemomancy to heal something, it also gains your con mod as temporary hit points for con mod rounds. This stacks with all other sources of temporary hit points.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Archwitch`,
        longDesc: `Increase the DC of all of your hexes by +2, and you count as 4 levels higher for the effects of your hexes. This does not grant you access to new hexes, only how powerful they are.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Spellslinger`,
        longDesc: `Increase the DC of all spells you cast by +1. If you can cast at least 5th level spells: once per turn you can cast a spell of 1st level or lower as a swift action that costs 8 spell points. A spell cast this way has no components and does not provoke. Once you can cast 8th level spells you can cast 2nd or lower spells as a swift action instead for 16 spell points.`,
        },
        {
        rarity: "unique",
        type: ["hands"],
        name: `Hands of the Magus`,
        longDesc: `Gain +4 to concentration checks. If you have the spell combat perk you can use your spellstrike ability an additional time per round, however the second spell costs 150% more instead of 50% more. Gain a bonus to attacks when using spell strike equal to the level of the spell.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robes of the Apocalypse`,
        longDesc: `Gain +3 to the damage of your spells per dice rolled.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robes of the Savior`,
        longDesc: `Increase the healing you do with spells and perks by +3 per dice rolled. If you have the Spontaneous Cure perk your aura ability has its radius increased by 10 feet, and once per day you can activate your aura as a free action instead of a movement action.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Master Summoner`,
        longDesc: `Whenever you use a spell or ability to summon more than 1 creature at a time increase the creatures summoned by 1. All creatures you summon gain a +2 bonus to attack and damage and DR -/3`,
        },
        {
        rarity: "epic",
        type: ["feet"],
        name: `Stagger-Proof Boots`,
        longDesc: `These calf-high leather boots are inscribed with a holy symbol. The wearer can stand up from prone without provoking attacks of opportunity and gains a +4 bonus to CMD against bull rush and trip combat maneuvers. Once per day as an immediate action, the wearer can move up to 30 feet; this movement provokes attacks of opportunity as normal.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Divine War-Kilt`,
        longDesc: `A favored item among the dervishes, this skirt of overlapping, brightly colored silk is magically reinforced, granting you increased durability and mobility. You gain a +2 natural armor bonus to AC and a +2 competence bonus on Acrobatics and Perform (dance) checks.
        
        Once per day, when an adjacent foe attempts to take a 5-foot step away from you, you may make a 5-foot step as an immediate action so long as you end up adjacent to that foe. If you take this step, you cannot take a 5-foot step during your next turn. If you take an action to move during your next turn, subtract 5 feet from your total movement.`,
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Anchoring Belt`,
        longDesc: `This belt looks like nothing more than iron chains connecting large pieces of slate. It grants its wearer a +5 inherent bonus to combat maneuver defense against bull rush, drag, grapple, overrun, reposition, and trip combat maneuvers and a +5 inherent bonus on saving throws against any effect that attempts to move the wearer with physical force or energy. Furthermore, if the wearer is targeted by an effect that would teleport her, she can choose whether or not she wishes to be teleported.
        
        As a standard action, the wearer can expend 15 spell points to create a 30-foot-radius aura that affects all enemy creatures within it as though they were subject to a dimensional anchor spell. This aura lasts 3 rounds.`,
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Mirroring Belt`,
        longDesc: `This broad belt is constructed of steel plates polished to a gleaming finish. The belt grants its wearer a +2 enhancement bonus to Dexterity.
        Three times per day, the wearer can use mirror image (standard action, CL 6) to bring forth illusory duplicates that persist for 5 rounds or until destroyed. These function as normal images from that spell, except any ranged attack (including ranged touch spells) that strikes and destroys an image rebounds onto the attacker, using the attacker's original result to determine whether the attack hits.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Infernal Cord`,
        longDesc: `The entirety of this thick hide belt is scarred with impressions of fiendish visages, each shifting between a scowl and a smile. This belt grants its wearer a +2 enhancement bonus to Constitution.
        Whenever an enemy scores a critical hit against the wearer, the wearer gains fast healing 1 for 1 minute, this fast healing is added to any other fast healing the wearer may have. This ability doesn't trigger if the critical hit deals only nonlethal damage. Damage caused by silver weapons, good-aligned weapons, or spells or effects with the good descriptor doesn't trigger the fast healing, and suppresses the fast healing for 1 round if it's already active.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Greater Infernal Cord`,
        longDesc: `The entirety of this thick hide belt is scarred with impressions of fiendish visages, each shifting between a scowl and a smile. This belt grants its wearer a +2 enhancement bonus to Constitution.
        Whenever an enemy scores a critical hit against the wearer, the wearer gains fast healing 4 for 1 minute, this fast healing is added to any other fast healing the wearer may have. This ability doesn't trigger if the critical hit deals only nonlethal damage. Damage caused by silver weapons, good-aligned weapons, or spells or effects with the good descriptor doesn't trigger the fast healing, and suppresses the fast healing for 1 round if it's already active.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Belt of Superior Maneuvers +1`,
        longDesc: `This thin, black canvas belt is typically tied loosely about the waist to secure a robe, kimono, or martial artist's dobok. Three times per day as a free action, the wearer can select a combat maneuver and receive an enhancement bonus of +1 on combat maneuver checks for this combat maneuver and a +1 bonus to CMD when defending against this maneuver for 1 round.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Belt of Superior Maneuvers +2`,
        longDesc: `This thin, black canvas belt is typically tied loosely about the waist to secure a robe, kimono, or martial artist's dobok. Three times per day as a free action, the wearer can select a combat maneuver and receive an enhancement bonus of +2 on combat maneuver checks for this combat maneuver and a +2 bonus to CMD when defending against this maneuver for 1 round.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Superior Maneuvers +3`,
        longDesc: `This thin, black canvas belt is typically tied loosely about the waist to secure a robe, kimono, or martial artist's dobok. Three times per day as a free action, the wearer can select a combat maneuver and receive an enhancement bonus of +3 on combat maneuver checks for this combat maneuver and a +3 bonus to CMD when defending against this maneuver for 1 round.`,
        },
        {
        rarity: "legendary",
        type: ["belt"],
        name: `Belt of Superior Maneuvers +5`,
        longDesc: `This thin, black canvas belt is typically tied loosely about the waist to secure a robe, kimono, or martial artist's dobok. Three times per day as a free action, the wearer can select a combat maneuver and receive an enhancement bonus of +5 on combat maneuver checks for this combat maneuver and a +5 bonus to CMD when defending against this maneuver for 1 round.`,
        },
        {
        rarity: "unique",
        type: ["belt"],
        name: `Belt of Superior Maneuvers +7`,
        longDesc: `This thin, black canvas belt is typically tied loosely about the waist to secure a robe, kimono, or martial artist's dobok. Three times per day as a free action, the wearer can select a combat maneuver and receive an enhancement bonus of +7 on combat maneuver checks for this combat maneuver and a +7 bonus to CMD when defending against this maneuver for 1 round.`,
        },
        {
        rarity: "legendary",
        type: ["hands"],
        name: `Gloves of Magical Aiming`,
        longDesc: `Increase the critical threat range of ray spell attacks by 1. This is a flat bonus and not multiplied by other abilities.`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Ghoulbane Belt`,
        longDesc: `Due to the toxic nature of many environments found within the Darklands, this belt is designed to protect its wearer from exotic diseases, paralyzing attacks, and poisonous molds. The wearer gains a +2 bonus on saving throws to resist disease, paralysis, and poison. This bonus increases to +4 on saving throws to resist such effects caused by molds or slimes. Additionally, the wearer can cast a single spell from the following list as a spell-like ability once per day: neutralize poison, remove disease, or remove paralysis. Activating this ability is a purely mental action that can be taken even while paralyzed or otherwise helpless. The chosen spell affects only the belt's wearer.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Canopic Wrap`,
        longDesc: `Tattered and yellowed, this belt is made up of dozens of interwoven linen wraps bound together by a simple stone buckle at the front. Crafted from mummifies' wrappings, these belts are commonly used by explorers in the vast deserts of what was once Ancient Osirion. While worn, the belt grants a +4 resistance bonus on saving throws against disease, including supernatural diseases such as mummy rot.
        
        A canopic wrap also causes strange internal shifts in key organs, moving them randomly within the body. Because of this odd effect, the wearer gains the benefits of the light fortificationUE armor special ability. This effect also plays havoc on trained healers, however, reduce the healing you get from any positive or negative energy by 1 (before other modifiers)`,
        },
        {
        rarity: "epic",
        type: ["belt"],
        name: `Belt of Spirit Vines`,
        longDesc: `The wearer can touch a willing creature and cause a ghostly vine to grow from the belt, connecting the wearer to the target creature. While connected to another creature, when the wearer casts a spell with a range of touch on herself, both the wearer and the connected creature gain the benefits of the spell for half the spell's duration (rounded down); this has no effect on instantaneous or permanent spells. The spell's effects on the connected creature end if the vine's range is exceeded.
        
        The vine can grow up to a length of 30 feet, and it vanishes if the wearer or connected creature moves beyond its maximum range. The vine can remain connected indefinitely, but the connection is broken if the wearer dismisses it or connects the vine to another creature.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Tightfit Belt`,
        longDesc: `As a free action, the wearer of this brown leather belt can compress himself to fit through tight spaces as though affected by a squeeze spell for up to 5 rounds per day. When using the belt's squeezing ability, the wearer gains a +5 circumstance bonus on Escape Artist checks. Once per day as a move action, the wearer can reduce his size by one step, as the reduce person spell, for 1 round. These effects can be used simultaneously.`,
        },
        {
        rarity: "common",
        type: ["belt"],
        name: `Victor's Belt`,
        longDesc: `This thick leather belt is adorned with several oversized iron plates and disks depicting images of orc gladiators in battle. The wearer of a victor's belt gains a +2 morale bonus on all combat maneuver checks and to Combat Maneuver Defense. In addition, the wearer can enter a rage (as the rage spell) as a standard action once per day. Whenever the wearer takes an amount of damage equal to at least half his current hit points in a single round, there is a 50% chance that the belt activates its rage ability automatically as an immediate action, provided the power has not already been activated that day and the wearer is not already raging. Regardless of how the rage is activated, it lasts for 5 rounds.`,
        },
        {
        rarity: "rare",
        type: ["belt"],
        name: `Gale Scabbard`,
        longDesc: `Once per day as a standard action, the wielder can speak the scabbard's command word to blast nearby creatures with gale-force winds. As part of activating the scabbard, the wielder can attempt a special trip combat maneuver check against all creatures within 10 feet using her normal CMB; this does not provoke attacks of opportunity. Creatures whose CMD is lower than the result are tripped. The wielder is not knocked down if the trip attempt fails by 10 or more.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Robe of the Master of Masters`,
        longDesc: `The wearer gains a +2 competence bonus on Perform checks. once per day as a free action the wearer can touch a tiny button on the wrist of the robe, granting her the effects of haste for 1 round, and heal all allies within 30 feet for 1 hit point.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Alabaster Trapping`,
        longDesc: `Once per day as an immediate action, the wearer can repel one creature physically touching her (such as a creature targeting her with a touch spell or a combat maneuver). The target of this effect takes 5d4 points of force damage and is pushed 10 feet in a direction specified by the wearer.`,
        },
        {
        rarity: "epic",
        type: ["body"],
        name: `Dhoti of Style Mastery`,
        longDesc: `When the wearer enters a stance while wearing a dhoti of style mastery, he gains 1d8+3 temporary hit points. These hit points stack, however, you cannot gain temporary hitpoints from moving into a stance more than once per round, nor can you gain temporary hit points from moving into a stance you have moved into on that day.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Hyperboreal Robe`,
        longDesc: `This beautiful robe is fashioned from fine blue silk embroidered with silver thread, and trimmed with owl feathers and tiny shards of crystal. The robe grants its wearer a +2 resistance bonus on all saving throws. In addition, the flesh of the robe's wearer becomes searing cold to the touch. Anyone who strikes the wearer with an unarmed strike, a touch attack, or a natural weapon takes 1d6 points of cold damage. The wearer can activate or deactivate this ability as a free action.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Lupine Robe`,
        longDesc: `This silk robe is covered in exquisitely detailed embroidery depicting foxes frolicking in a pristine meadow. Three times per day, the wearer can add 1d6 to the result of a Dexterity-, Intelligence-, or Charisma-based skill check as a free action. The wearer can do this only once per check`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Crusader's Tabard`,
        longDesc: `Once per day, the wearer of the tabard may say its command word (Free action); thereafter, the wearer can spend a standard action (instead of a full-round action) to move up to his speed and make a single charge attack. This ability lasts until used or for 1 minute, whichever duration is shorter.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Flag Tabbard`,
        longDesc: `Once per day as a standard action, the wearer can cause a flag tabard to flare with protective energy. All creatures with the same alignment within a 60-foot radius gain a +2 sacred bonus to AC and CMD for 5 rounds. If the wearer is evil this is a profane bonus instead.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Neili Robes`,
        longDesc: `This black-and-white robe is specially crafted to help the wearer regulate the flow of ki in his body, allowing for the generation of internal strength. Once per round when the wearer spends a spell point on a ki perk or flurry of blows, he gains a +1 natural armor bonus to AC and a +1 enhancement bonus to Strength for 1 round. If the wearer spends another spell point on a ki perk or flurry of blows before the end of his next turn, the duration is extended by 1 round and the natural armor and enhancement bonuses are increased by 1 (to a maximum of +4). The bonuses to AC and Strength last for only 1 round following the expenditure of the last spell point on required abilities.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Vestments of War`,
        longDesc: `The robes act as a divine focus for divine casters, allowing spells requiring a divine focus to be cast without the need to hold any other holy symbol. Additionally, the wearers channel energy, lay on hands, healing hexes, fervor, and soothing song all heal 3 additional hit points.`,
        },
        {
        rarity: "epic",
        type: ["body"],
        name: `Hamatulatsu Robe`,
        longDesc: `This robe can only be worn by evil creatures. Gain a +3 dodge bonus to your armor class while unarmored, and increase the damage of your unarmed attacks by 1 step. Your critical hits with unarmed attacks cause the foe to become sickened for 1 round (or staggered for 1 round if the target is already sickened). Multiple critical hits in a round against a single foe do not increase the duration of the sickened or staggered condition.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Habit of the Winter Explorer`,
        longDesc: `This warm outfit consists of a woolen coat and pants, boots, gloves, and a heavy fur cloak with a leather hood. The habit of the winter explorer provides a constant endure elements effect in cold weather (it has no effect in warm weather), and the wearer gains a +2 bonus on saving throws against magic cold effects and spells with the cold descriptor.
        
        The wearer's eyes turn a piercing sky blue color. The wearer becomes immune to snow blindness and gains the ability to see through natural or magical fog, sleet, snow, and other similar weather conditions with a range of 60 feet.
        
        The habit of the winter explorer also grants its wearer a +4 competence bonus on Stealth checks made while in snow. In addition, once per day while in snow snow, the wearer may turn invisible for 3 rounds as the vanish spell (CL3). the spell ends if wearer leaves the area with snow.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Untouchable Jacket`,
        longDesc: `Once per day, the wearer can speak a command word (standard) to gain spell resistance 20 for 3 rounds. This spell resistance ends if the wearer successfully resists a spell as a result of it failing to penetrate his spell resistance. The first time each day that a spell has no effect on the wearer because of spell resistance or a successful saving throw, the jacket becomes charged with abjuration magic and its insignia glows faintly. The wearer can touch the glowing insignia as a standard action to cast dispel magic from the jacket, expending the charge. The charge fades with no effect if unused for 1 hour.`,
        },
        {
        rarity: "common",
        type: ["body"],
        name: `Corset of Dire Witchcraft`,
        longDesc: `Gain a +2 deflection bonus to armor class. You count as 2 levels higher for the effect of your hexes.`,
        },
        {
        rarity: "rare",
        type: ["body"],
        name: `Cassock of the Black Monk`,
        longDesc: `This ankle-length black robe, cut in the style favored by Orthodox priests, bears little outward ornamentation beyond its gold buttons, though subtle occult symbols embroidered in black thread decorate the skirt's hem. The cassock of the Black Monk grants a +4 luck bonus to the wearer's touch AC. In addition, while wearing the cassock, once per day when casting a spell he can cause it to deal full effect against incorporeal or ethereal creatures as the ectoplasmic spell metamagic feat, without increasing the casting time, spell points cost, and without level adjustment.`,
        },
        {
        rarity: "epic",
        type: ["body"],
        name: `Robe of Runes`,
        longDesc: `This robe is made of crimson silk and emblazoned with dozens of spindly Thassilonian runes, each symbolizing a different type of magical effect or syllable of power. Though favored by wizards, this robe can provide some benefit to any spellcasting creature. While worn, it grants a +4 enhancement bonus to Intelligence and allows the wearer to cast up to 4 levels of spells each day without expending spell points (modifications to the spell must still be paid normally as if the spell cost was not reduced). Each time a spell is cast in this manner, the sudden rush of magical energy infuses the wearer with power. For 1 round after casting a spell (not affecting the current spell), the wearer's spell save DCs and attack rolls made with spells gain a +2 enhancement bonus.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of the Overmind`,
        longDesc: `This regal-looking robe is trimmed with softly glowing sigils. The wearer gains DR 2/-, spell resistance 18, +4 resistance bonus on all saving throws, the save DC's of all spells of the control type increase by +1.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robe of Magma`,
        longDesc: `These striking black robes are lined with glowing cracks, and resemble flows of partially cooled magma. The wearer gains fire resistance 20 and immunity to fire damage from lava and magma. Additionally, while submerged in lava or magma, the wearer can breathe normally, gains a +5 bonus on Swim checks, and can see through the substance as clearly as if it were water.
        
        Additionally, once per day as a full-round action, the wearer of a robe of magma can conjure a great burst of magma from deep below the surface, which arrives within 1d4 rounds. It bursts from the ground in a geyser that sprays up to 40 feet in height and showers a 20-foot radius centered on the location of the wearer when this ability was activated. This deals 20d6 points of fire damage to creatures in the area (Reflex DC 22 half) and creates a shallow pool of lava in the area of the burst. The magma geyser continues for 1d3 rounds. For each round that the geyser continues, the pool of lava expands its radius by 10 feet. Creatures that enter the pool of lava or begin their turn in this area take 2d6 points of fire damage. Once the magma geyser stops, this pool cools and hardens over the course of 1d3 rounds. The magma arrives through an extradimensional space and does not impact any features or terrain located under its point of conjuration.`,
        },
        {
        rarity: "unique",
        type: ["body"],
        name: `Robes of Calm Casting`,
        longDesc: `Woven of the finest of crimson silks and accented with precious gold, the robes are surprisingly light and easy to move in. The robes of Xin- Bakrakhan aid and accentuate their wearer's spellcasting ability. They grant a +5 shield bonus and spell resistance 24, and the wearer casts all spells at +1 caster level. The wearer of these robes is immune to the effects of calm emotions and can use all skills and abilities that require patience or concentration when under the effects of a rage spell or similar effect. Twice per day you can retrieve an item from your inventory as a free action that does not provoke an attack of opportunity. This includes potions, gems, and gear items (not weapons).`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Apron of the Careful Chemist`,
        longDesc: `This leather apron is made from several layers of thick hide from common beasts of burden and is reinforced with steel rivets. The apron grants its wearer a +2 enhancement bonus to Dexterity. In addition, the wearer gains a +4 competence bonus on Craft checks. When the wearer uses a grenade or bomb that requires a reflex saving throw the DC is increased by 1, except for creatures he designates when throwing the grenade, in which case the DC decreases by 1.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Deadshot Vest`,
        longDesc: `Once per day when the wearer reduces a creature to 0 or fewer hit points she can use death knell (Will DC 13 + the creature's negative hit points) against that target as a swift action. She does not have to touch the target to activate this ability.`,
        },
        {
        rarity: "common",
        type: ["chest"],
        name: `Blouse of the Boastful Bastard`,
        longDesc: `Whenever the wearer takes damage from a successful critical hit they regain 3 spell points.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Swordmaster's Shirt`,
        longDesc: `This stylish silk shirt has a loose and flowing fit except for the sleeves, which cling snugly to the wearer's arms from elbow to wrist. The sleeves guide the wearer's attacks to take advantage of brief gaps in a foe's defenses. Five times per day the wearer can make a lunging melee maneuver and extend his reach by 5 feet for a single melee attack. If the wearer has the Lunge feat, he can instead use that feat five times per day without taking the normal -2 penalty.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Shadow Jumper's Tunic`,
        longDesc: `The wearer of this jacket can jump up to 40 feet per day as a free action. It cannot be used to jump any less than 10 feet at a time, and the jumps must be long jumps. The jumps provoke as normal, but an additional acrobatics check can be made while doing them to avoid attacks of opportunity as normal.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Shadowbond Tunic`,
        longDesc: `As a standard action once per day you can bind yourself to a target within touch range, for the next 24 hours whenever the wielder is adjacent to that ally and that ally takes damage, the wielder can sacrifice up to 10 hit points to prevent an equal amount of damage done to the ally. This damage cannot be reduced or redirected, and if the wielder is incapable of sacrificing hit points, the damage to the ally cannot be prevented.`,
        },
        {
        rarity: "rare",
        type: ["chest"],
        name: `Scaled Sash`,
        longDesc: `Glittering with every movement, this sash is associated with a specific type of chromatic dragon. The first time the sash is used the user may choose the energy type, (fire, cold, electricity, acid) once the sash is used for a specific energy type the sash can only convert damage to that type. Three times per day, the wearer may convert all the damage dealt by a single attack with a melee, ranged, or natural weapon into the matching dragon's breath weapon damage type. The amount of damage dealt remains unaffected. The sash may be used after the attack's results are known, but must be declared before damage has been rolled. Attacks dealing any type of energy damage cannot be converted in this manner unless the energy type of the original damage is the same as that granted by the scaled sash. If the original attack would be affected by damage reduction, the converted damage is reduced as if it did not bypass the damage reduction, even if the target has no special defenses against the converted energy type.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Mantle of Spell Resistance`,
        longDesc: `This light mantle bears a variety of mysterious symbols. When worn over normal clothing or armor, this magical garment grants the wearer spell resistance 21.`,
        },
        {
        rarity: "legendary",
        type: ["chest"],
        name: `Mantle of the Crusader Host`,
        longDesc: `This holy shroud is inscribed with hundreds of sacred passages in homage to the gods of good. It can only be worn by good creatures, and grants damage reduction 5/evil to the character wearing it. Against the attacks of creatures with the demon subtype, the damage reduction becomes 5/—.`,
        },
        {
        rarity: "legendary",
        type: ["feet"],
        name: `Earthquake Boots`,
        longDesc: `These thick hide boots allow the wearer to detect unseen enemies, and they provide a final line of defense against overwhelming foes. The wearer gains tremorsense with a range of up to 60 feet as long as she is standing on solid ground. Additionally, once per day, by stomping repeatedly on an earthen or stone surface as a full-round action that provokes attacks of opportunity, the wearer can cast earthquake as a spell-like ability.`,
        },
        {
        rarity: "legendary",
        type: ["feet"],
        name: `Boots of the Battle Herald`,
        longDesc: `These boots are made of fine white leather tooled with scenes of epic battles. Once per day as a move action, the wearer can affect himself with greater heroism for 11 rounds. (CL11)`,
        },
        {
        rarity: "epic",
        type: ["feet"],
        name: `Getaway Boots`,
        longDesc: `These rather nondescript boots can, once per day, be attuned to a location their wearer is standing upon. Once the boots are attuned to a location, once per day as a movement action, the wearer, along with anything she is wearing or carrying, teleports back to the attuned location as the getaway spell, except that no allies are teleported when the boots are activated even if they were in the area when the boots were attuned to their location. `,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Combat Sandals`,
        longDesc: `Worked brown leather straps run up the backs and around the soles of this sturdy set of footwear. The wearer of a pair of combat sandals can charge through allies' squares without difficulty, and allies adjacent to the wearer don't provide cover to targets the wearer attacks with reach or ranged weapons.`,
        },
        {
        rarity: "rare",
        type: ["feet"],
        name: `Bastion Boots`,
        longDesc: `These metal boots are engraved with the imagery of The Keep, and evoke the unwavering determination represented by that card. The boots can be used as an immovable rod, even when worn. If the boots are moved, the wearer moves with the boots. Even while not activated, bastion boots grant the wearer a +4 bonus to her CMD against combat maneuvers to move her.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Gloves of Stolen Unlife`,
        longDesc: `These pale gray gauntlets feature cabochons of banded black onyx that slowly shift to white when the gloves are activated. Three times per day, the wearer can activate the gloves as a swift action after successfully affecting an undead creature with an offensive single-target spell. Doing so grants the wearer a number of temporary hit points equal to 10 + the Hit Dice of the affected undead (maximum +10), which last a number of minutes equal to the level of the spell cast. This effect ends immediately if either glove is removed.`,
        },
        {
        rarity: "common",
        type: ["hands"],
        name: `Aristocrats Gloves`,
        longDesc: `Once per day, the wearer can summon a surge of invisible force to knock back a single target within 40 feet. The wearer attempts a combat maneuver check to bull rush one creature or object with a +5 bonus. This bull rush combat maneuver doesn't provoke an attack of opportunity.`,
        },
        {
        rarity: "rare",
        type: ["hands"],
        name: `Skullcrusher Gauntlets`,
        longDesc: `Once per day, the wearer can unleash a devastating attack with the gauntlets that can instantly knock a target unconscious. The wearer must announce her intent before making her attack roll, and creatures immune to critical hits can't be affected. To make the attack, the wearer makes a single melee attack at her highest base attack bonus as a full-round action. If the strike hits, the target takes 4d6 points of force damage and must succeed at a DC 8+bab Fortitude save or fall unconscious until the end of its next turn. Even if the target succeeds at the Fortitude save, it is staggered until the end of its next turn.`,
        },
        {
        rarity: "unique",
        type: ["neck"],
        name: `Necklace of Ensured Return`,
        longDesc: `At the time of her death while wearing this necklace, the wearer's soul is moved into its gemstone, and must choose a period of time ranging from 1 to 14 rounds. After the selected amount of time passes, the gemstone shatters, releasing the dead wearer's soul. Her body then immediately re-forms in a space within 60 feet of where the gem shattered, regardless of the condition of her body at the time of her death, as per true resurrection.
        
        If the gem is destroyed prior to the elapsing of the specified time, the dead wearer's body re-forms immediately. The individual whose soul is released from the necklace can choose where her body re-forms at the time the gem shatters. Once the former wearer is resurrected, the necklace turns to lead and becomes worthless. It is a new body and the wearer must retrieve their equipment`,
        },
        {
        rarity: "legendary",
        type: ["neck"],
        name: `Necklace of Lovelies`,
        longDesc: `This repugnant and cruel magic item consists of a chain of cold iron on which dangle six tiny, cold iron cages, each of which contains a living but miniaturized pixie. While the pixies are free to shriek and yell and cry, the item prevents them from taking any action that would directly free them from their cage and suppresses all of their supernatural and spell-like abilities.
        
        As a swift action, the wearer of a necklace of lovelies can redirect hit point damage inflicted on him from any single attack or effect that damages him onto one of the pixies on the necklace—doing so automatically kills the poor pixie in a tiny explosion of blood. Once all of the necklace's pixies are dead or released, the necklace becomes nonmagical.
        
        The magic of a necklace of lovelies can also be released by breaking open one of the tiny pixie's cage, after which it immediately bestows luck upon the wearer. The luck granted by this effect can be used at any point once during the next 3 days as a swift action whenever a d20 is rolled—it allows the lucky soul to roll 2d20 and pick which result he wishes to accept.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Amulet of Quaking Strikes`,
        longDesc: `This simple bronze amulet depicts a mountaintop being shattered by a sword blow. Once per day, the amulet's wearer can make a single melee attack against the ground as a standard action. The wearer can choose a point of origin within 100 feet of himself and apply his attack roll against all creatures within a 20-foot radius of that point. The amulet's wearer rolls his attack's damage once and applies it to all creatures in the affected area. The damage includes the weapon's base damage dice, the wearer's Strength modifier, and damage from feats such as Power Attack and Vital Strike; it doesn't include damage from other magical sources, such as enhancement bonuses, spells, and magic weapon special abilities.`,
        },
        {
        rarity: "epic",
        type: ["neck"],
        name: `Gallows Rope`,
        longDesc: `While the noose is worn tightly around the neck, any time the wearer is reduced below 0 hit points he gains DR 10/— and fast healing 5 until he regains consciousness. While the wearer is unconscious, his breathing stops and he appears dead.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Monkey's Paw`,
        longDesc: `This tiny, shrunken, mummified monkey hand is worn around the neck on a leather strap. Once per day as a free action, the wearer of a monkey's paw may reroll one attack roll, skill check, or saving throw. The reroll must be made before the result of the initial die roll is known. The second die roll must be used even if the result is worse than the original roll. If the second die roll is worse than the original, the wearer suffers a sense of impending doom, causing him to be shaken for 1d4 rounds.`,
        },
        {
        rarity: "rare",
        type: ["head"],
        name: `Goz Mask`,
        longDesc: `A goz mask allows the wearer to see through fog, smoke, and other obscuring vapors as if they did not exist. This ability functions underwater as well, allowing the wearer to see through thick silt and other aquatic precipitates. Additionally, the wearer is treated as one size category larger and gains a +4 bonus on all saving throws made to resist the effects of wind. A goz mask allows its wearer to breathe water for 60 minutes per day—these minutes need not be consecutive, but must be expended in 10-minute increments.`,
        },
        {
            rarity: "rare",
            type: ["feet"],
            name: `Crashing Boots`,
            longDesc: `Grant their wearer a +2 bonus on attack rolls when charging. In addition, once per day when the wearer hits a Large or smaller creature with an attack, he can send his foe flying 10 feet. The foe must be thrown in a straight line away from the wearer, and lands prone at the end of the movement. If an obstacle prevents the completion of the opponent's move, the opponent and the obstacle each take 1d6 points of damage, and the opponent is knocked prone in the space adjacent to the obstacle.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Cloak of Disarming`,
        longDesc: `This cloak is well crafted and stylish. As a swift action, the wearer can direct the cloak to attempt a combat maneuver check to disarm a creature within 5 feet, using the wearer's CMB. This disarm combat maneuver does not provoke attacks of opportunity. If the attempt fails, the wearer doesn't risk losing the cloak.`,
        },
        {
        rarity: "epic",
        type: ["shoulders"],
        name: `Mantle of Life`,
        longDesc: `This short cape shimmers faintly under light. The wearer is immune to the energy drain attacks made by undead creatures. She still suffers any other effects of the attack, but ignores the energy drain.`,
        },
        {
        rarity: "epic",
        type: ["wrist"],
        name: `Bracers of Might`,
        longDesc: `These golden bracers are sculpted to depict a pair of mighty stags rearing up in triumph. They grant a +4 bonus on all Strength ability checks and Strength-based skill checks. As a swift action up to three times per day, the wearer can call upon the power of these bracers to gain a +4 sacred bonus to Strength for 1 round.`,
        },
        {
        rarity: "common",
        type: ["neck"],
        name: `Fortunate Charm`,
        longDesc: `Once per day, this good luck charm allows the wearer to reroll a single skill check or concentration check after the success or failure of the original roll is known. The result of the reroll must be kept, even if it is worse than the original roll. The charm may not be used on a skill check that's already been rerolled by some other means.`,
        },
        {
            rarity: "common",
            type: ["untyped"],
            name: `+1 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },
        {
            rarity: "rare",
            type: ["untyped"],
            name: `+1 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },
        {
            rarity: "epic",
            type: ["untyped"],
            name: `+1 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },

        {
            rarity: "rare",
            type: ["untyped"],
            name: `+2 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },
        {
            rarity: "epic",
            type: ["untyped"],
            name: `+2 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },
        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+2 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },

        {
            rarity: "epic",
            type: ["untyped"],
            name: `+3 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },
        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+3 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+3 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },

        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+4 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+4 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+4 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },

        {
            rarity: "common",
            type: ["untyped"],
            name: `+1 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },
        {
            rarity: "rare",
            type: ["untyped"],
            name: `+1 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },
        {
            rarity: "epic",
            type: ["untyped"],
            name: `+1 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","1"]
        },

        {
            rarity: "rare",
            type: ["untyped"],
            name: `+2 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },
        {
            rarity: "epic",
            type: ["untyped"],
            name: `+2 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },
        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+2 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","2"]
        },

        {
            rarity: "epic",
            type: ["untyped"],
            name: `+3 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },
        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+3 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+3 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","3"]
        },

        {
            rarity: "legendary",
            type: ["untyped"],
            name: `+4 Minor Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 3 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+4 Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell must be of level 6 or lower. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },
        {
            rarity: "unique",
            type: ["untyped"],
            name: `+4 Greater Metamagic Rod`,
            longDesc: `While holding this rod you can apply the listed metamagic effects to spells as they are cast twice per day. The spell can be of any level. This does not change the spell slot of the altered spell. A caster may only use one metamagic rod on any given spell, but it is permissible to combine a rod with metamagic feats possessed by the rod's wielder. The listed feat is:`,
            special:["rod","4"]
        },
        
]